import React, { useState, useEffect } from "react";
import {
  Tabs,
  Table,
  Form,
  Input,
  Drawer,
  Steps,
  Select,
  Collapse,
  Modal,
  Dropdown, Option
} from "antd";
import { get,post,remove } from "../../Services/Api";
import Loading from "../../Components/Loading";
import AdminSidebar from "../../Components/AdminSidebar";
import AddImg from "./../../Assets/images/white-add.svg";
import AddBlackImg from "./../../Assets/images/add.svg";
import ShareImg from "./../../Assets/images/share.svg";
import DeleteRatioImg from "./../../Assets/images/delete-ratio.svg";
import EditRatioImg from "./../../Assets/images/edit-ratio.svg";
import EditImg from "./../../Assets/images/edit.svg";
import DeleteImg from "./../../Assets/images/delete.svg";
import SearchIconImg from "../../Assets/images/search.svg";
import CloseImg from "../../Assets/images/close-new.svg";
import InfoImg from "./../../Assets/images/info.svg";
import BaseRatioImg from "./../../Assets/images/base_ratio.svg";
import CaptiveRatioImg from "./../../Assets/images/captive_ratio.svg";
import Driving_adjusmentImg from "./../../Assets/images/driving_adjustment.svg";
import { PlusOutlined, MinusOutlined } from "@ant-design/icons";
import { notification } from 'antd';
import SaveImg from "./../../Assets/images/save.svg";
import DeletConformation from "../../Components/DeleteConformation";

const { Panel } = Collapse;

const { Step } = Steps;

const RangeTable = () => {
  const [tableData, setTableData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [activeTable, setActiveTable] = useState("weekday");
  const [activeTableModal, setActiveTableModal] = useState("weekday");
  const [categoryList,setcategoryList] = useState([]);
  const [customCategory,setcustomCategory] = useState([]);
  const [landuseID,setlanduseID] = useState("");
  const [activeKeys, setActiveKeys] = useState([]);
  const [selectedCategoryName,setSelectedCategoryName] = useState("")
  const [isModalVisible,setisModalVisible] = useState(false)
  const [isDeleteModalVisible, setisDeleteModalVisible] = useState(false)
  const [isEditMode,setIsEditMode] = useState(false)
  const [adminId,setAdminId] = useState("");
  const [unitList, setUnitList] = useState([]);
  const [selectedUnitValue, setSelectedUnitValue] = useState("units");

  const [filteredCategories, setFilteredCategories] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");


  // const [customCategoryCopy,setcustomCategoryCopy] = useState([]);
  const [customCategoryCopyWeekday,setcustomCategoryCopyWeekday] = useState([]);
  const [customCategoryCopyWeekend,setcustomCategoryCopyWeekend] = useState([]);

  const [customVistorBaseRatio,setCustomVistorBaseRatio] = useState("");
  const [customEmployeeBaseRatio,setCustomEmployeeBaseRatio] = useState("");

  const [customVistorBaseRatioWeekend,setCustomVistorBaseRatioWeekend] = useState("");
  const [customEmployeeBaseRatioWeekend,setCustomEmployeeBaseRatioWeekend] = useState("");

  const [customVisitorDaytimeCaptiveRatio,setCustomVisitorDaytimeCaptiveRatio] = useState("")
  const [customVisitorEveningCaptiveRatio,setCustomVisitorEveningCaptiveRatio] = useState("")

  const [customVisitorDaytimeCaptiveRatioWeekend,setCustomVisitorDaytimeCaptiveRatioWeekend] = useState("")
  const [customVisitorEveningCaptiveRatioWeekend,setCustomVisitorEveningCaptiveRatioWeekend] = useState("")

  const [customEmployeeDaytimeCaptiveRatio,setCustomEmployeeDaytimeCaptiveRatio] = useState("")
  const [customEmployeeEveningCaptiveRatio,setCustomEmployeeEveningCaptiveRatio] = useState("")

  const [customEmployeeDaytimeCaptiveRatioWeekend,setCustomEmployeeDaytimeCaptiveRatioWeekend] = useState("")
  const [customEmployeeEveningCaptiveRatioWeekend,setCustomEmployeeEveningCaptiveRatioWeekend] = useState("")

  const [customVisitorDaytimeDrivingRatio,setCustomVisitorDaytimeDrivingRatio] = useState("")
  const [customVisitorEveningDrivingRatio,setCustomVisitorEveningDrivingRatio] = useState("")

  const [customVisitorDaytimeDrivingRatioWeekend,setCustomVisitorDaytimeDrivingRatioWeekend] = useState("")
  const [customVisitorEveningDrivingRatioWeekend,setCustomVisitorEveningDrivingRatioWeekend] = useState("")

  const [customEmployeeDaytimeDrivingRatio,setCustomEmployeeDaytimeDrivingRatio] = useState("")
  const [customEmployeeEveningDrivingRatio,setCustomEmployeeEveningDrivingRatio] = useState("")

  const [customEmployeeDaytimeDrivingRatioWeekend,setCustomEmployeeDaytimeDrivingRatioWeekend] = useState("")
  const [customEmployeeEveningDrivingRatioWeekend,setCustomEmployeeEveningDrivingRatioWeekend] = useState("")

  const [customVisitorJan,setCustomVisitorJan] = useState("")
  const [customVisitorFeb,setCustomVisitorFeb] = useState("")
  const [customVisitorMar,setCustomVisitorMar] = useState("")
  const [customVisitorApr,setCustomVisitorApr] = useState("")
  const [customVisitorMay,setCustomVisitorMay] = useState("")
  const [customVisitorJun,setCustomVisitorJun] = useState("")
  const [customVisitorJul,setCustomVisitorJul] = useState("")
  const [customVisitorAug,setCustomVisitorAug] = useState("")
  const [customVisitorSep,setCustomVisitorSep] = useState("")
  const [customVisitorOct,setCustomVisitorOct] = useState("")
  const [customVisitorNov,setCustomVisitorNov] = useState("")
  const [customVisitorDec,setCustomVisitorDec] = useState("")
  const [customVisitorLateDec,setCustomVisitorLateDec] = useState("")

  const [customEmployeeJan,setCustomEmployeeJan] = useState("")
  const [customEmployeeFeb,setCustomEmployeeFeb] = useState("")
  const [customEmployeeMar,setCustomEmployeeMar] = useState("")
  const [customEmployeeApr,setCustomEmployeeApr] = useState("")
  const [customEmployeeMay,setCustomEmployeeMay] = useState("")
  const [customEmployeeJun,setCustomEmployeeJun] = useState("")
  const [customEmployeeJul,setCustomEmployeeJul] = useState("")
  const [customEmployeeAug,setCustomEmployeeAug] = useState("")
  const [customEmployeeSep,setCustomEmployeeSep] = useState("")
  const [customEmployeeOct,setCustomEmployeeOct] = useState("")
  const [customEmployeeNov,setCustomEmployeeNov] = useState("")
  const [customEmployeeDec,setCustomEmployeeDec] = useState("")
  const [customEmployeeLateDec,setCustomEmployeeLateDec] = useState("")

  const [customVisitorJanWeekend,setCustomVisitorJanWeekend] = useState("")
  const [customVisitorFebWeekend,setCustomVisitorFebWeekend] = useState("")
  const [customVisitorMarWeekend,setCustomVisitorMarWeekend] = useState("")
  const [customVisitorAprWeekend,setCustomVisitorAprWeekend] = useState("")
  const [customVisitorMayWeekend,setCustomVisitorMayWeekend] = useState("")
  const [customVisitorJunWeekend,setCustomVisitorJunWeekend] = useState("")
  const [customVisitorJulWeekend,setCustomVisitorJulWeekend] = useState("")
  const [customVisitorAugWeekend,setCustomVisitorAugWeekend] = useState("")
  const [customVisitorSepWeekend,setCustomVisitorSepWeekend] = useState("")
  const [customVisitorOctWeekend,setCustomVisitorOctWeekend] = useState("")
  const [customVisitorNovWeekend,setCustomVisitorNovWeekend] = useState("")
  const [customVisitorDecWeekend,setCustomVisitorDecWeekend] = useState("")
  const [customVisitorLateDecWeekend,setCustomVisitorLateDecWeekend] = useState("")

  const [customEmployeeJanWeekend,setCustomEmployeeJanWeekend] = useState("")
  const [customEmployeeFebWeekend,setCustomEmployeeFebWeekend] = useState("")
  const [customEmployeeMarWeekend,setCustomEmployeeMarWeekend] = useState("")
  const [customEmployeeAprWeekend,setCustomEmployeeAprWeekend] = useState("")
  const [customEmployeeMayWeekend,setCustomEmployeeMayWeekend] = useState("")
  const [customEmployeeJunWeekend,setCustomEmployeeJunWeekend] = useState("")
  const [customEmployeeJulWeekend,setCustomEmployeeJulWeekend] = useState("")
  const [customEmployeeAugWeekend,setCustomEmployeeAugWeekend] = useState("")
  const [customEmployeeSepWeekend,setCustomEmployeeSepWeekend] = useState("")
  const [customEmployeeOctWeekend,setCustomEmployeeOctWeekend] = useState("")
  const [customEmployeeNovWeekend,setCustomEmployeeNovWeekend] = useState("")
  const [customEmployeeDecWeekend,setCustomEmployeeDecWeekend] = useState("")
  const [customEmployeeLateDecWeekend,setCustomEmployeeLateDecWeekend] = useState("")

  const [timeVarianceData, setTimeVarianceData] = useState([]);
  const [visitorData, setVisitorData] = useState([]);
  const [employeeData, setEmployeeData] = useState([]);
  const [visitorInputs, setVisitorInputs] = useState([]);
  const [employeeInputs, setEmployeeInputs] = useState([]);

  const [visitorDataWeekend, setVisitorDataWeekend] = useState([]);
  const [visitorInputsWeekend, setVisitorInputsWeekend] = useState([]);
  const [employeeDataWeekend, setEmployeeDataWeekend] = useState([]);
  const [employeeInputsWeekend, setEmployeeInputsWeekend] = useState([]);
  const [customName,setcustomName] = useState("")

   // Define state variables for form values
   const [customVisitorEditBaseRatio, setCustomVisitorEditBaseRatio] = useState("");
   const [customVisitorEditBaseRatioWeekend, setCustomVisitorEditBaseRatioWeekend] = useState("");
   const [customEmployeeEditBaseRatio, setCustomEmployeeEditBaseRatio] = useState("");
   const [customEmployeeEditBaseRatioWeekend, setCustomEmployeeEditBaseRatioWeekend] = useState("");

   const [editedLandUseName, setEditedLandUseName] = useState("");

   let columnKeys = [
    "6AM", "7AM", "8AM", "9AM", "10AM", "11AM", "12PM",
    "1PM", "2PM", "3PM", "4PM", "5PM", "6PM", "7PM", 
    "8PM", "9PM", "10PM", "11PM", "12AM"
  ];
  




  //

   useEffect(() => {
          const userId = localStorage.getItem("adminId");
          setAdminId(userId)
        }, []);

  const [open, setOpen] = useState(false);
  const showDrawer = () => {
    setIsEditMode(false)
    setOpen(true);
  };


  //
  const onChanges = (value) => {
    console.log(`selected ${value}`);
  };
  const onSearch = (value) => {
    console.log("search:", value);
  };

  const handleCollapseChange = (keys) => {
    setActiveKeys(keys); // Update the active collapse keys
  };

  
  useEffect(()=>{
    fetchCategory()
  },[])

  useEffect(() => {
    if (searchTerm.trim() === "") {
      setFilteredCategories(categoryList);
    } else {
      const filtered = categoryList.filter((category) =>
        category.category_name.toLowerCase().includes(searchTerm.toLowerCase()) || 
        category.land_uses.some((land) => 
          land.land_use_name.toLowerCase().includes(searchTerm.toLowerCase())
        )
      );
      setFilteredCategories(filtered);
    }
  }, [searchTerm, categoryList]);


  

  const fetchCategory = async () => {
    try {
      // const response = await get(`http://192.168.96.120:5000/apis/listcategory`);
      const response = await get(`listcategory`);
      if (response?.status === 200) {
        setcategoryList(response.data.categories);
        setFilteredCategories(response.data.categories);
      } else {
        throw new Error("Invalid API response");
      }
    } catch (error) {
      notification.error({
        message: "Error Fetching Category Details",
        description: "Unable to fetch category. Please try again later.",
      });
    }
  };

  const handleUnitChange = (e) => {
    const value = e.target.value;
    setSelectedUnitValue(value); 
  };

  useEffect(()=>{
    const fetchUnitList = async () => {
      try {
        // const response = await get(`http://192.168.96.120:5000/apis/unitlist`);
        const response = await get(`unitlist`);
        if (response?.status === 200) {
          setUnitList(response.data);
        } else {
          throw new Error("Invalid API response");
        }
      } catch (error) {
        notification.error({
          message: "Error Fetching Unit List",
          description: error.message || "Unable to fetch units. Please try again later.",
        });
      }
    };

    fetchUnitList();
  },[])

  useEffect(() => {
    fetchDataLanduse();
  }, [landuseID, activeTable,isEditMode]);

  // useEffect(()=>{
    const fetchDataLanduse = async () => {
      if (!landuseID) return; // Exit early if landuseID is not set

      try {
        // const endpoint =
        //   activeTable === "weekday"
        //     ? `http://192.168.96.120:5000/apis/landusedetailsingleweekday?land_use_code=${landuseID}`
        //     : `http://192.168.96.120:5000/apis/landusedetailsingleweekend?land_use_code=${landuseID}`;

        const endpoint =
          activeTable === "weekday"
            ? `landusedetailsingleweekday?land_use_code=${landuseID}`
            : `landusedetailsingleweekend?land_use_code=${landuseID}`;

        const response = await get(endpoint);

        if (response.status === 200) {
          console.log("response.data::", response.data);
          setcustomCategory(response.data);
          // setcustomCategoryCopy(response.data)
          // assignCategoryValues();
        } else {
          console.error("Failed to fetch data:", response.status);
        }
      } catch (e) {
        console.error("Error fetching data:", e);
      }
    }

  //   fetchDataLanduse();
    
  // },[landuseID,activeTable])

  console.log("categoryList::",categoryList);

  const customDeleteModal = ()=>{
    setisDeleteModalVisible(true)
  }

  const handleDeleteModalCancel = () =>{
    setisDeleteModalVisible(false);
  }
  
  const customDelete =  async()=>{
    const landUseName = customCategoryCopyWeekday?.data[0]?.land_use;

  if (!landUseName) {
    console.error("land_use_name is undefined or invalid.");
    return;
  }

  console.log("customCategoryCopyWeekday.land_use::", landUseName);

  try {
    // const response = await remove(`http://192.168.96.120:5000/apis/deletecustomlanduse?land_use_name=${landUseName}`);
    const response = await remove(`deletecustomlanduse?land_use_name=${landUseName}`);

    // const response = await post(`/deletecustomlanduse`, {
    //   land_use_name: landUseName,
    // });

    if (response.status === 200) {
     fetchCategory();

     notification.success({
      message: "Deleted Succesfully",
      // description: "Deleted Record",
    });
    setisDeleteModalVisible(false);
    setTimeout(() => {
      window.location.reload();
    }, 800); 

    }

    console.log("Delete successful:", response);
  } catch (error) {
    console.error("Error during deletion:", error);
  }
  }


  useEffect(() => {
    const fetchData = async () => {
      if (!landuseID) return; // Exit early if landuseID is not set
  
      try {
        const weekdayEndpoint = `landusedetailsingleweekday?land_use_code=${landuseID}`;
        const weekendEndpoint = `landusedetailsingleweekend?land_use_code=${landuseID}`;
  
        // Fetch both data concurrently
        const [weekdayResponse, weekendResponse] = await Promise.all([
          get(weekdayEndpoint),
          get(weekendEndpoint),
        ]);
  
        // Handle responses
        if (weekdayResponse.status === 200) {
          setcustomCategoryCopyWeekday(weekdayResponse.data);
        } else {
          console.error("Failed to fetch weekday data:", weekdayResponse.status);
        }
  
        if (weekendResponse.status === 200) {
          setcustomCategoryCopyWeekend(weekendResponse.data);
        } else {
          console.error("Failed to fetch weekend data:", weekendResponse.status);
        }
        // Set unit value from the first available response
        const unitValue = weekendResponse.data?.data?.[0]?.unit || weekdayResponse.data?.data?.[0]?.unit || "units";
        setSelectedUnitValue(unitValue);
        
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };
  
    fetchData();
  }, [landuseID,isEditMode]);

  console.log("customCategoryCopyWeekend::",customCategoryCopyWeekend);
  console.log("customCategoryCopyWeekday::",customCategoryCopyWeekday);
  
  console.log("customCategory::",customCategory);

  const handleCancelSaveModal= ()=>{
    setisModalVisible(false)
  }

  const handleEditRatios = async()=>{
    console.log("Edit!!!")
    const combinedInputs = [
      ...[visitorInputs, visitorInputsWeekend, employeeInputs, employeeInputsWeekend].flat().map((input) => ({
        ...input.data,
        time: input.time,
        parker: input.parker,
        category: input.category,
      })),
    ];
    console.log("combinedInputs::",combinedInputs);
    
    const payload = {
      land_use_code: customCategory?.data[0]?.land_code,
      land_use_name: editedLandUseName,
      // land_use_name: customCategory?.data[0]?.land_use,
      // land_use_name: customName, 
      land_use_category: selectedCategoryName,   
      status: "custom",              
      unit: "sf GLA",
      // unit: selectedUnitValue,               
      season: ["Weekday", "Weekend"], 
      // parker: ["Visitor/Customer", "Employee"], 
      parker:Object.values(customCategoryCopyWeekday.parkers),
      base_ratio: [
        {
          time: "Weekday",
          parker: customCategoryCopyWeekday?.parkers.weekday_visitor,
          unit: "sf GLA",
          value: parseFloat(customVistorBaseRatio) || 0, 
        },
        {
          time: "Weekend",
          parker: customCategoryCopyWeekend?.parkers.weekend_visitor,
          unit: "sf GLA",
          value: parseFloat(customVistorBaseRatioWeekend) || 0, 
        },
        {
          time: "Weekday",
          parker: customCategoryCopyWeekday?.parkers.weekday_employee,
          unit: "sf GLA",
          value: parseFloat(customEmployeeBaseRatio) || 0, 
        },
        {
          time: "Weekend",
          parker: customCategoryCopyWeekend?.parkers.weekend_employee,
          unit: "sf GLA",
          value: parseFloat(customEmployeeBaseRatioWeekend) || 0, 
        },
      ],
      monthly_ratio: [
        {
          time: "Weekday",
          parker: "Visitor/Customer",
          jan: parseFloat(customVisitorJan),
          feb: parseFloat(customVisitorFeb),
          mar: parseFloat(customVisitorMar),
          apr: parseFloat(customVisitorApr),
          may: parseFloat(customVisitorMay),
          jun: parseFloat(customVisitorJun),
          jul: parseFloat(customVisitorJul),
          aug: parseFloat(customVisitorAug),
          sep: parseFloat(customVisitorSep),
          oct: parseFloat(customVisitorOct),
          nov: parseFloat(customVisitorNov),
          dec: parseFloat(customVisitorDec),
          late_dec: parseFloat(customVisitorLateDec)
        },
        {
          time: "Weekend",
          parker: "Visitor/Customer",
          jan: parseFloat(customVisitorJanWeekend),
          feb: parseFloat(customVisitorFebWeekend),
          mar: parseFloat(customVisitorMarWeekend),
          apr: parseFloat(customVisitorAprWeekend),
          may: parseFloat(customVisitorMayWeekend),
          jun: parseFloat(customVisitorJunWeekend),
          jul: parseFloat(customVisitorJulWeekend),
          aug: parseFloat(customVisitorAugWeekend),
          sep: parseFloat(customVisitorSepWeekend),
          oct: parseFloat(customVisitorOctWeekend),
          nov: parseFloat(customVisitorNovWeekend),
          dec: parseFloat(customVisitorDecWeekend),
          late_dec: parseFloat(customVisitorLateDecWeekend)
        },
        {
          time: "Weekday",
          parker: "Employee",
          jan: parseFloat(customEmployeeJan),
          feb: parseFloat(customEmployeeFeb),
          mar: parseFloat(customEmployeeMar),
          apr: parseFloat(customEmployeeApr),
          may: parseFloat(customEmployeeMay),
          jun: parseFloat(customEmployeeJun),
          jul: parseFloat(customEmployeeJul),
          aug: parseFloat(customEmployeeAug),
          sep: parseFloat(customEmployeeSep),
          oct: parseFloat(customEmployeeOct),
          nov: parseFloat(customEmployeeNov),
          dec: parseFloat(customEmployeeDec),
          late_dec: parseFloat(customEmployeeLateDec)
        },
        {
          time: "Weekend",
          parker: "Employee",
          jan: parseFloat(customEmployeeJanWeekend),
          feb: parseFloat(customEmployeeFebWeekend),
          mar: parseFloat(customEmployeeMarWeekend),
          apr: parseFloat(customEmployeeAprWeekend),
          may: parseFloat(customEmployeeMayWeekend),
          jun: parseFloat(customEmployeeJunWeekend),
          jul: parseFloat(customEmployeeJulWeekend),
          aug: parseFloat(customEmployeeAugWeekend),
          sep: parseFloat(customEmployeeSepWeekend),
          oct: parseFloat(customEmployeeOctWeekend),
          nov: parseFloat(customEmployeeNovWeekend),
          dec: parseFloat(customEmployeeDecWeekend),
          late_dec: parseFloat(customEmployeeLateDecWeekend)
        }
      ],
      time_ratio: combinedInputs,
      driving_adj:[
                    {
                        time:"Weekday",
                        category:"Daytime",
                        parker:customCategoryCopyWeekday?.parkers.weekday_visitor,
                        value: parseFloat(customVisitorDaytimeDrivingRatio) || 0,
                    },
                    {
                        time:"Weekday",
                        category:"Evening",
                        parker:customCategoryCopyWeekday?.parkers.weekday_visitor,
                        value: parseFloat(customVisitorEveningDrivingRatio) || 0,
                    },
                    {
                        time:"Weekend",
                        category:"Daytime",
                        parker:customCategoryCopyWeekend?.parkers.weekend_visitor,
                        value: parseFloat(customVisitorDaytimeDrivingRatioWeekend) || 0,
                    },
                    {
                        time:"Weekend",
                        category:"Evening",
                        parker:customCategoryCopyWeekend?.parkers.weekend_visitor,
                        value: parseFloat(customVisitorEveningDrivingRatioWeekend) || 0,
                    },
                    {
                        time:"Weekday",
                        category:"Daytime",
                        parker:customCategoryCopyWeekday?.parkers.weekday_employee,
                        value: parseFloat(customEmployeeDaytimeDrivingRatio) || 0,
                    },
                    {
                        time:"Weekday",
                        category:"Evening",
                        parker:customCategoryCopyWeekday?.parkers.weekday_employee,
                        "value": parseFloat(customEmployeeEveningDrivingRatio) || 0,
                    },
                    {
                        time:"Weekend",
                        category:"Daytime",
                        parker:customCategoryCopyWeekend?.parkers.weekend_employee,
                        value: parseFloat(customEmployeeDaytimeDrivingRatioWeekend) || 0,
                    },
                    {
                        time:"Weekend",
                        category:"Evening",
                        parker:customCategoryCopyWeekend?.parkers.weekend_employee,
                        value: parseFloat(customEmployeeEveningDrivingRatioWeekend) || 0,
                    }
                ],
              captive_ratio:[
                  {
                      time:"Weekday",
                      category:"Daytime",
                      parker:"Visitor/Customer",
                      value: parseFloat(customVisitorDaytimeCaptiveRatio) || 0,
                  },
                  {
                      time:"Weekday",
                      category:"Evening",
                      parker:"Visitor/Customer",
                      value: parseFloat(customVisitorEveningCaptiveRatio) || 0,
                  },
                  {
                      time:"Weekend",
                      category:"Daytime",
                      parker:"Visitor/Customer",
                      value: parseFloat(customVisitorDaytimeCaptiveRatioWeekend) || 0,
                  },
                  {
                      time:"Weekend",
                      category:"Evening",
                      parker:"Visitor/Customer",
                      value: parseFloat(customVisitorEveningCaptiveRatioWeekend) || 0,
                  },
                  {
                      time:"Weekday",
                      category:"Daytime",
                      parker:"Employee",
                      value: parseFloat(customEmployeeDaytimeCaptiveRatio) || 0,
                  },
                  {
                      time:"Weekday",
                      category:"Evening",
                      parker:"Employee",
                      value: parseFloat(customEmployeeEveningCaptiveRatio) || 0,
                  },
                  {
                      time:"Weekend",
                      category:"Daytime",
                      parker:"Employee",
                      value: parseFloat(customEmployeeDaytimeCaptiveRatioWeekend) || 0,
                  },
                  {
                      time:"Weekend",
                      category:"Evening",
                      parker:"Employee",
                      value: parseFloat(customEmployeeEveningCaptiveRatioWeekend) || 0,
                  }
              ],     
              
    };

    try {
      // const response = await post('http://192.168.96.120:5000/apis/editcustomlanduse', payload);
      const response = await post('editcustomlanduse', payload);
    
      if (response.status === 200) {
        setIsEditMode(false)
        fetchDataLanduse()
        fetchCategory()
        notification.success({
          message: 'Land Use Edited Successfully',
        });
  
      }
    } catch (error) {
      notification.error({
        message: 'Error On Editing Land Use',
        description: error.message || 'An error occurred while editing land use data.',
      });
    }
    
  }
  

  const handleCategorylist = async (landId,categoryName) =>{
    setlanduseID(landId)
    setSelectedCategoryName(categoryName)
    setIsEditMode(false)
    setActiveTableModal("weekday")
    setActiveTable("weekday")
  }

  // console.log("customCategory::",customCategory);
  // console.log("landuseID::",landuseID);
  // console.log("categoryList::",categoryList);
  
   const renderModalContent = () => {
          return (
              <Form layout="vertical">
                 <div className="w-100 text-center">
                      <img src={SaveImg} alt="" className="mb-2" />
                      <h5>
                      Save 
                      </h5>
                 </div>
                  {/* <Form.Item
                      name="template_name"
                      className="mt-2"
                      rules={[
                          { required: true, message: 'Please enter the name' },
                      ]}
                  >
                      <Input placeholder="Please enter the name" value={template_name} onChange={handletemplateName} className="mt-4" />
                  </Form.Item> */}
  
                  <div className="mb-3 mt-2">
                      <input
                      type="text"
                      id="templateName"
                      className="form-control mt-4"
                      placeholder="Provide a suitable name"
                      value={customName}
                      onChange={(e)=>setcustomName(e.target.value)}
                      required
                      />
                      <div className="invalid-feedback">Please enter the name</div>
                  </div>
  
                 
                  <Form.Item className="text-end">
                      <button className="me-2 btn" onClick={handleCancelSaveModal}>
                          Cancel
                      </button>
                      <button type="submit"  className="btn btn-primary" onClick={handleSaveCustom} >
                          Save
                      </button>
                  </Form.Item>
              </Form>
          );
        };

  const itemsSidebar = [
    {
      key: "1",
      label: "Food & Beverage",
      children: (
        <ul className="category-style">
          <li className="active">
            <span className="category-list">Fine/Casual Dining</span>
            <span className="default-style">DEFAULT</span>
          </li>
          <li>
            <span className="category-list">Fine/Casual Dining_co...</span>
            <span className="custom-style">CUSTOM</span>
          </li>
          <li>
            <span className="category-list">Fine/Casual Dining</span>
            <span className="default-style">DEFAULT</span>
          </li>
          <li>
            <span className="category-list">Fine/Casual Dining</span>
            <span className="default-style">DEFAULT</span>
          </li>
        </ul>
      ),
    },
    {
      key: "2",
      label: "Retail",
      children: (
        <ul className="category-style">
          <li>
            <span className="category-list">Fine/Casual Dining</span>
            <span className="default-style">DEFAULT</span>
          </li>
          <li className="">
            <span className="category-list">Fine/Casual Dining_co...</span>
            <span className="custom-style">CUSTOM</span>
          </li>
          <li>
            <span className="category-list">Fine/Casual Dining</span>
            <span className="default-style">DEFAULT</span>
          </li>
          <li>
            <span className="category-list">Fine/Casual Dining</span>
            <span className="default-style">DEFAULT</span>
          </li>
        </ul>
      ),
    },
    {
      key: "3",
      label: "Entertainment & Institutions",
      children: (
        <ul className="category-style">
          <li>
            <span className="category-list">Fine/Casual Dining</span>
            <span className="default-style">DEFAULT</span>
          </li>
          <li>
            <span className="category-list">Fine/Casual Dining_co...</span>
            <span className="custom-style">CUSTOM</span>
          </li>
          <li>
            <span className="category-list">Fine/Casual Dining</span>
            <span className="default-style">DEFAULT</span>
          </li>
          <li>
            <span className="category-list">Fine/Casual Dining</span>
            <span className="default-style">DEFAULT</span>
          </li>
        </ul>
      ),
    },
    {
      key: "4",
      label: "Hotel & Residential",
      children: (
        <ul className="category-style">
          <li>
            <span className="category-list">Fine/Casual Dining</span>
            <span className="default-style">DEFAULT</span>
          </li>
          <li>
            <span className="category-list">Fine/Casual Dining_co...</span>
            <span className="custom-style">CUSTOM</span>
          </li>
          <li>
            <span className="category-list">Fine/Casual Dining</span>
            <span className="default-style">DEFAULT</span>
          </li>
          <li>
            <span className="category-list">Fine/Casual Dining</span>
            <span className="default-style">DEFAULT</span>
          </li>
        </ul>
      ),
    },
    {
      key: "5",
      label: "Office",
      children: (
        <ul className="category-style">
          <li>
            <span className="category-list">Fine/Casual Dining</span>
            <span className="default-style">DEFAULT</span>
          </li>
          <li>
            <span className="category-list">Fine/Casual Dining_co...</span>
            <span className="custom-style">CUSTOM</span>
          </li>
          <li>
            <span className="category-list">Fine/Casual Dining</span>
            <span className="default-style">DEFAULT</span>
          </li>
          <li>
            <span className="category-list">Fine/Casual Dining</span>
            <span className="default-style">DEFAULT</span>
          </li>
        </ul>
      ),
    },
    {
      key: "6",
      label: "Additional Land Uses",
      children: (
        <ul className="category-style">
          <li>
            <span className="category-list">Fine/Casual Dining</span>
            <span className="default-style">DEFAULT</span>
          </li>
          <li>
            <span className="category-list">Fine/Casual Dining_co...</span>
            <span className="custom-style">CUSTOM</span>
          </li>
          <li>
            <span className="category-list">Fine/Casual Dining</span>
            <span className="default-style">DEFAULT</span>
          </li>
          <li>
            <span className="category-list">Fine/Casual Dining</span>
            <span className="default-style">DEFAULT</span>
          </li>
        </ul>
      ),
    },

  //   {categoryList.categories.catemap((catList)=>(
  //   {
  //     key: "1",
  //     label: "Food & Beverage",
  //     children: (
  //       <ul className="category-style">
  //         <li className="active">
  //           <span className="category-list">Fine/Casual Dining</span>
  //           <span className="default-style">DEFAULT</span>
  //         </li>
  //         <li>
  //           <span className="category-list">Fine/Casual Dining_co...</span>
  //           <span className="custom-style">CUSTOM</span>
  //         </li>
  //         <li>
  //           <span className="category-list">Fine/Casual Dining</span>
  //           <span className="default-style">DEFAULT</span>
  //         </li>
  //         <li>
  //           <span className="category-list">Fine/Casual Dining</span>
  //           <span className="default-style">DEFAULT</span>
  //         </li>
  //       </ul>
  //     ),
  //   }
  // ))}
  ];

  // sidebar
  const columns = [
    {
      title: "Weekday Visitor",
      dataIndex: "weekday_visitor",
      key: "weekday_visitor",
      align: "center",
    },
    {
      title: "Weekday Employee",
      dataIndex: "weekday_employee",
      key: "weekday_employee",
      align: "center",
    },
  ];

  // Tab items configuration

  const handleEditMode = ()=>{
    setIsEditMode((prev)=> !prev)
  }

  useEffect(() => {
    if (customCategory?.data?.length > 0) {
      setCustomVisitorEditBaseRatio(customCategoryCopyWeekday.data[0]?.weekday_visitor_base_ratio || "");
      setCustomVisitorEditBaseRatioWeekend(customCategoryCopyWeekend.data[0]?.weekend_visitor_base_ratio || "");
      setCustomEmployeeEditBaseRatio(customCategoryCopyWeekday.data[0]?.weekday_employee_base_ratio || "");
      setCustomEmployeeEditBaseRatioWeekend(customCategoryCopyWeekend.data[0]?.weekend_employee_base_ratio || "");

      setCustomVisitorDaytimeCaptiveRatio(customCategoryCopyWeekend.data[0]?.daytime_weekday_visitor_captive_ratio || "")
      //
      // setCustomVisitorDaytimeEditCaptiveRatio(
      //   activeTable === "weekday"
      //     ? customCategory.data[0]?.daytime_weekday_visitor_captive_ratio || ""
      //     : customCategory.data[0]?.daytime_weekend_visitor_captive_ratio || ""
      // );
    }

    // setCustomVisitorDaytimeCaptiveRatio()
  }, [customCategoryCopyWeekday, customCategoryCopyWeekday]);


  console.log("customcategory to test for bug fix:::",customCategory);
  
  
  const items = [
    {
      key: "1",
      label: "Base Ratio",
      children: (
        <div className="table-responsive">
          <table className="table table-dark base-ratio-table pb-0 mb-0">
            <tbody>
              <tr className="">
                <td style={{ width: "30%" }}>
                  {/* Visitor */}
                  {customCategory?.data?.length > 0
                  ? activeTable === "weekday"
                    ? customCategory.parkers?.weekday_visitor
                    : customCategory.parkers?.weekend_visitor
                  : 0}
                  </td>
                
                <td>
                {/* {customCategory?.data?.length > 0
                  ? activeTable === "weekday"
                    ? customCategory.data[0]?.weekday_visitor_base_ratio
                    : customCategory.data[0]?.weekend_visitor_base_ratio
                  : 0} */}
                  {customCategoryCopyWeekday?.data?.length && customCategoryCopyWeekend?.data?.length && customCategory?.data?.length > 0 ? (
                    isEditMode ? (
                      <input
                        type="text"
                        className="modal-input"
                        // value={
                        //   activeTable === "weekday"
                        //     ? customVisitorEditBaseRatio
                        //     : customVisitorEditBaseRatioWeekend
                        // }
                        value={
                          activeTable === "weekday"
                            ? customVistorBaseRatio
                            : customVistorBaseRatioWeekend
                        }
                        // onChange={(e) =>
                        //   activeTable === "weekday"
                        //     ? setCustomVisitorEditBaseRatio(e.target.value)
                        //     : setCustomVisitorEditBaseRatioWeekend(e.target.value)
                        // }
                        onChange={(e) =>{
                          const inputValue = e.target.value;
                          // Allow only numbers and decimals using regex
                          if (/^\d*\.?\d*$/.test(inputValue)) {
                          activeTable === "weekday"
                            ? setCustomVistorBaseRatio(inputValue)
                            : setCustomVistorBaseRatioWeekend(inputValue)
                          }
                        }
                        }
                      />
                    ) : activeTable === "weekday" ? (
                      customCategory.data[0]?.weekday_visitor_base_ratio
                    ) : (
                      customCategory.data[0]?.weekend_visitor_base_ratio
                    )
                  ) : (
                    0
                  )}
              </td>
              </tr>
              <tr>
                <td style={{ width: "30%" }}>
                  {/* Employee */}
                  {customCategory?.data?.length > 0
                  ? activeTable === "weekday"
                    ? customCategory.parkers?.weekday_employee
                    : customCategory.parkers?.weekend_employee
                  : 0}
                  
                  </td>
                {/* <td>{activeTable === "weekday" ? customCategory?.data[0]?.weekday_employee_base_ratio: customCategory?.data[0]?.weekend_employee_base_ratio}</td> */}
                <td>
                {/* {customCategory?.data?.length > 0
                  ? activeTable === "weekday"
                    ? customCategory.data[0].weekday_employee_base_ratio
                    : customCategory.data[0].weekend_employee_base_ratio
                  : 0} */}

                  {/* // */}

                  {customCategoryCopyWeekday?.data?.length && customCategoryCopyWeekend?.data?.length && customCategory?.data?.length> 0 ? (
                    isEditMode ? (
                      <input
                        type="text"
                        className="modal-input"
                        // value={
                        //   activeTable === "weekday"
                        //     ? customEmployeeEditBaseRatio
                        //     : customEmployeeEditBaseRatioWeekend
                        // }
                        value={
                          activeTable === "weekday"
                            ? customEmployeeBaseRatio
                            : customEmployeeBaseRatioWeekend
                        }
                        // onChange={(e) =>
                        //   activeTable === "weekday"
                        //     ? setCustomEmployeeEditBaseRatio(e.target.value)
                        //     : setCustomEmployeeEditBaseRatioWeekend(e.target.value)
                        // }
                        onChange={(e) =>{
                          const inputValue = e.target.value;
                          // Allow only numbers and decimals using regex
                          if (/^\d*\.?\d*$/.test(inputValue)) {
                          activeTable === "weekday"
                            ? setCustomEmployeeBaseRatio(inputValue)
                            : setCustomEmployeeBaseRatioWeekend(inputValue)
                          }
                        }
                        }
                      />
                    ) : activeTable === "weekday" ? (
                      customCategory.data[0]?.weekday_employee_base_ratio
                    ) : (
                      customCategory.data[0]?.weekend_employee_base_ratio
                    )
                  ) : (
                    0
                  )}

              </td>
              </tr>
              {/* <tr>
                <td style={{ width: "30%" }}>Total</td>
                <td>15.50</td>
              </tr> */}
            </tbody>
          </table>
        </div>
      ),
    },
    {
      key: "2",
      label: "Monthly Ratio",
      children: (
        <div className="table-responsive">
          <table className="table table-dark base-ratio-table pb-0 mb-0">
            <tbody>
              <tr>
                <td></td>
                <td>Jan</td>
                <td>Feb</td>
                <td>Mar</td>
                <td>Apr</td>
                <td>May</td>
                <td>Jun</td>
                <td>Jul</td>
                <td>Aug</td>
                <td>Sep</td>
                <td>Oct</td>
                <td>Nov</td>
                <td>Dec</td>
                <td>Late Dec</td>
              </tr>
              {/* {customCategory?.montly_ratio?.length > 0 ? (
                customCategory.montly_ratio.map((ratio, index) => (
                  <tr key={index} className="text-center">
                    <td>{ratio?.parker || 0}</td>
                    <td>{ratio?.jan || 0}</td>
                    <td>{ratio?.feb || 0}</td>
                    <td>{ratio?.mar || 0}</td>
                    <td>{ratio?.apr || 0}</td>
                    <td>{ratio?.may || 0}</td>
                    <td>{ratio?.jun || 0}</td>
                    <td>{ratio?.jul || 0}</td>
                    <td>{ratio?.aug || 0}</td>
                    <td>{ratio?.sep || 0}</td>
                    <td>{ratio?.oct || 0}</td>
                    <td>{ratio?.nov || 0}</td>
                    <td>{ratio?.dec || 0}</td>
                    <td>{ratio?.late_dec || 0}</td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan="14">No data available</td>
                </tr>
              )} */}

              {isEditMode ? (
              activeTable === "weekday" ? (
                <>
                  {/* Weekday Visitor Row */}
                  <tr>
                    <td>{customCategoryCopyWeekday?.parkers?.weekday_visitor || 0}</td>
                    <td>
                      <input
                        type="text"
                        className="modal-input"
                        value={customVisitorJan}
                        onChange={(e) =>{
                          const inputValue = e.target.value;
                            if (/^\d*\.?\d*$/.test(inputValue)) {
                           setCustomVisitorJan(inputValue)
                            }}
                          }
                      />
                    </td>
                    <td>
                      <input
                        type="text"
                        className="modal-input"
                        value={customVisitorFeb}
                        onChange={(e) =>{
                          const inputValue = e.target.value;
                            if (/^\d*\.?\d*$/.test(inputValue)) {
                           setCustomVisitorFeb(inputValue)
                            }}
                          
                          }
                      />
                    </td>
                    <td>
                      <input
                        type="text"
                        className="modal-input"
                        value={customVisitorMar}
                        onChange={(e) =>{
                          const inputValue = e.target.value;
                            if (/^\d*\.?\d*$/.test(inputValue)) {
                           setCustomVisitorMar(inputValue)
                            }}
                          }
                      />
                    </td>
                    <td>
                      <input
                        type="text"
                        className="modal-input"
                        value={customVisitorApr}
                        onChange={(e) =>{
                          const inputValue = e.target.value;
                            if (/^\d*\.?\d*$/.test(inputValue)) {
                           setCustomVisitorApr(inputValue)
                            }}
                          }
                      />
                    </td>
                    <td>
                      <input
                        type="text"
                        className="modal-input"
                        value={customVisitorMay}
                        onChange={(e) =>{
                          const inputValue = e.target.value;
                            if (/^\d*\.?\d*$/.test(inputValue)) {
                           setCustomVisitorMay(inputValue)
                          }
                            }}
                      />
                    </td>
                    <td>
                      <input
                        type="text"
                        className="modal-input"
                        value={customVisitorJun}
                        onChange={(e) =>{
                          const inputValue = e.target.value;
                            if (/^\d*\.?\d*$/.test(inputValue)) {
                           setCustomVisitorJun(inputValue)
                            }}
                          }
                      />
                    </td>
                    <td>
                      <input
                        type="text"
                        className="modal-input"
                        value={customVisitorJul}
                        onChange={(e) =>{
                          const inputValue = e.target.value;
                            if (/^\d*\.?\d*$/.test(inputValue)) {
                           setCustomVisitorJul(inputValue)
                        }}
                          }
                      />
                    </td>
                    <td>
                      <input
                        type="text"
                        className="modal-input"
                        value={customVisitorAug}
                        onChange={(e) =>{
                          const inputValue = e.target.value;
                            if (/^\d*\.?\d*$/.test(inputValue)) {
                           setCustomVisitorAug(inputValue)
                            }}
                          }
                      />
                    </td>
                    <td>
                      <input
                        type="text"
                        className="modal-input"
                        value={customVisitorSep}
                        onChange={(e) =>{
                          const inputValue = e.target.value;
                            if (/^\d*\.?\d*$/.test(inputValue)) {
                           setCustomVisitorSep(inputValue)
                            }}
                          }
                      />
                    </td>
                    <td>
                      <input
                        type="text"
                        className="modal-input"
                        value={customVisitorOct}
                        onChange={(e) =>{
                          const inputValue = e.target.value;
                            if (/^\d*\.?\d*$/.test(inputValue)) {
                           setCustomVisitorOct(inputValue)
                            }}
                          }
                      />
                    </td>
                    <td>
                      <input
                        type="text"
                        className="modal-input"
                        value={customVisitorNov}
                        onChange={(e) =>{
                          const inputValue = e.target.value;
                            if (/^\d*\.?\d*$/.test(inputValue)) {
                           setCustomVisitorNov(inputValue)
                            }}
                          }
                      />
                    </td>
                    <td>
                      <input
                        type="text"
                        className="modal-input"
                        value={customVisitorDec}
                        onChange={(e) => {
                          const inputValue = e.target.value;
                            if (/^\d*\.?\d*$/.test(inputValue)) {
                          setCustomVisitorDec(inputValue)
                            }}
                        }
                      />
                    </td>
                    <td>
                      <input
                        type="text"
                        className="modal-input"
                        value={customVisitorLateDec}
                        onChange={(e) => {
                          const inputValue = e.target.value;
                            if (/^\d*\.?\d*$/.test(inputValue)) {
                          setCustomVisitorLateDec(inputValue)
                            }}
                        }
                      />
                    </td>
                    {/* // */}
                  </tr>
                  {/* Weekday Employee Row */}
                  <tr>
                    <td>{customCategoryCopyWeekday?.parkers?.weekday_employee || 0}</td>
                    <td>
                      <input
                        type="text"
                        className="modal-input"
                        value={customEmployeeJan}
                        onChange={(e) =>{
                          const inputValue = e.target.value;
                            if (/^\d*\.?\d*$/.test(inputValue)) {
                           setCustomEmployeeJan(inputValue)
                            }}
                          }
                      />
                    </td>
                    <td>
                      <input
                        type="text"
                        className="modal-input"
                        value={customEmployeeFeb}
                        onChange={(e) => {
                          const inputValue = e.target.value;
                            if (/^\d*\.?\d*$/.test(inputValue)) {
                          setCustomEmployeeFeb(inputValue)
                            }}
                        }
                      />
                    </td>
                    <td>
                      <input
                        type="text"
                        className="modal-input"
                        value={customEmployeeMar}
                        onChange={(e) => {
                          const inputValue = e.target.value;
                            if (/^\d*\.?\d*$/.test(inputValue)) {
                          setCustomEmployeeMar(inputValue)
                        }}
                        }
                      />
                    </td>
                    <td>
                      <input
                        type="text"
                        className="modal-input"
                        value={customEmployeeApr}
                        onChange={(e) =>{
                          const inputValue = e.target.value;
                            if (/^\d*\.?\d*$/.test(inputValue)) {
                           setCustomEmployeeApr(inputValue)
                        }}
                          }
                      />
                    </td>
                    <td>
                      <input
                        type="text"
                        className="modal-input"
                        value={customEmployeeMay}
                        onChange={(e) =>{
                          const inputValue = e.target.value;
                            if (/^\d*\.?\d*$/.test(inputValue)) {
                           setCustomEmployeeMay(inputValue)
                        }}
                          }
                      />
                    </td>
                    <td>
                      <input
                        type="text"
                        className="modal-input"
                        value={customEmployeeJun}
                        onChange={(e) =>{
                          const inputValue = e.target.value;
                            if (/^\d*\.?\d*$/.test(inputValue)) {
                           setCustomEmployeeJun(inputValue)
                        }}
                          }
                      />
                    </td>
                    <td>
                      <input
                        type="text"
                        className="modal-input"
                        value={customEmployeeJul}
                        onChange={(e) => {
                          const inputValue = e.target.value;
                            if (/^\d*\.?\d*$/.test(inputValue)) {
                          setCustomEmployeeJul(inputValue)
                            }}
                        }
                      />
                    </td>
                    <td>
                      <input
                        type="text"
                        className="modal-input"
                        value={customEmployeeAug}
                        onChange={(e) =>{
                          const inputValue = e.target.value;
                            if (/^\d*\.?\d*$/.test(inputValue)) {
                           setCustomEmployeeAug(inputValue)
                        }}
                          }
                      />
                    </td>
                    <td>
                      <input
                        type="text"
                        className="modal-input"
                        value={customEmployeeSep}
                        onChange={(e) =>{
                          const inputValue = e.target.value;
                            if (/^\d*\.?\d*$/.test(inputValue)) {
                           setCustomEmployeeSep(inputValue)
                            }}
                          }
                      />
                    </td>
                    <td>
                      <input
                        type="text"
                        className="modal-input"
                        value={customEmployeeOct}
                        onChange={(e) =>{
                          const inputValue = e.target.value;
                            if (/^\d*\.?\d*$/.test(inputValue)) {
                           setCustomEmployeeOct(inputValue)
                        }}
                          }
                      />
                    </td>
                    <td>
                      <input
                        type="text"
                        className="modal-input"
                        value={customEmployeeNov}
                        onChange={(e) => {
                          const inputValue = e.target.value;
                            if (/^\d*\.?\d*$/.test(inputValue)) {
                          setCustomEmployeeNov(inputValue)
                            }}
                        }
                      />
                    </td>
                    <td>
                      <input
                        type="text"
                        className="modal-input"
                        value={customEmployeeDec}
                        onChange={(e) =>{
                          const inputValue = e.target.value;
                            if (/^\d*\.?\d*$/.test(inputValue)) {
                           setCustomEmployeeDec(inputValue)
                            }}
                          }
                      />
                    </td>
                    <td>
                      <input
                        type="text"
                        className="modal-input"
                        value={customEmployeeLateDec}
                        onChange={(e) => {
                          const inputValue = e.target.value;
                            if (/^\d*\.?\d*$/.test(inputValue)) {
                          setCustomEmployeeLateDec(inputValue)
                            }}
                        }
                      />
                    </td>
                   
                  </tr>
                </>
              ) : activeTable === "weekend" ? (
                <>
                  {/* Weekend Visitor Row */}
                  <tr>
                    <td>{customCategoryCopyWeekend?.parkers?.weekend_visitor || 0}</td>
                    <td>
                      <input
                        type="text"
                        className="modal-input"
                        value={customVisitorJanWeekend}
                        onChange={(e) =>{
                          const inputValue = e.target.value;
                            if (/^\d*\.?\d*$/.test(inputValue)) {
                           setCustomVisitorJanWeekend(inputValue)
                        }}
                          }
                      />
                    </td>
                    <td>
                      <input
                        type="text"
                        className="modal-input"
                        value={customVisitorFebWeekend}
                        onChange={(e) =>{
                          const inputValue = e.target.value;
                            if (/^\d*\.?\d*$/.test(inputValue)) {
                           setCustomVisitorFebWeekend(inputValue)
                        }}
                          }
                      />
                    </td>
                    <td>
                      <input
                        type="text"
                        className="modal-input"
                        value={customVisitorMarWeekend}
                        onChange={(e) =>{
                          const inputValue = e.target.value;
                            if (/^\d*\.?\d*$/.test(inputValue)) {
                           setCustomVisitorMarWeekend(inputValue)
                        }}
                          }
                      />
                    </td>
                    <td>
                      <input
                        type="text"
                        className="modal-input"
                        value={customVisitorAprWeekend}
                        onChange={(e) =>{
                          const inputValue = e.target.value;
                            if (/^\d*\.?\d*$/.test(inputValue)) {
                           setCustomVisitorAprWeekend(inputValue)
                            }}
                          }
                      />
                    </td>
                    <td>
                      <input
                        type="text"
                        className="modal-input"
                        value={customVisitorMayWeekend}
                        onChange={(e) =>{
                          const inputValue = e.target.value;
                            if (/^\d*\.?\d*$/.test(inputValue)) {
                           setCustomVisitorMayWeekend(inputValue)
                            }}
                          }
                      />
                    </td>
                    <td>
                      <input
                        type="text"
                        className="modal-input"
                        value={customVisitorJunWeekend}
                        onChange={(e) =>{
                          const inputValue = e.target.value;
                            if (/^\d*\.?\d*$/.test(inputValue)) {
                           setCustomVisitorJunWeekend(inputValue)
                            }}
                          }
                      />
                    </td>
                    <td>
                      <input
                        type="text"
                        className="modal-input"
                        value={customVisitorJulWeekend}
                        onChange={(e) =>{
                          const inputValue = e.target.value;
                            if (/^\d*\.?\d*$/.test(inputValue)) {
                           setCustomVisitorJulWeekend(inputValue)
                            }}
                          }
                      />
                    </td>
                    <td>
                      <input
                        type="text"
                        className="modal-input"
                        value={customVisitorAugWeekend}
                        onChange={(e) =>{
                          const inputValue = e.target.value;
                            if (/^\d*\.?\d*$/.test(inputValue)) {
                           setCustomVisitorAugWeekend(inputValue)
                            }}
                          }
                      />
                    </td>
                    <td>
                      <input
                        type="text"
                        className="modal-input"
                        value={customVisitorSepWeekend}
                        onChange={(e) => {
                          const inputValue = e.target.value;
                            if (/^\d*\.?\d*$/.test(inputValue)) {
                          setCustomVisitorSepWeekend(inputValue)
                        }}
                        }
                      />
                    </td>
                    <td>
                      <input
                        type="text"
                        className="modal-input"
                        value={customVisitorOctWeekend}
                        onChange={(e) =>{
                          const inputValue = e.target.value;
                            if (/^\d*\.?\d*$/.test(inputValue)) {
                           setCustomVisitorOctWeekend(inputValue)
                            }}
                          }
                      />
                    </td>
                    <td>
                      <input
                        type="text"
                        className="modal-input"
                        value={customVisitorNovWeekend}
                        onChange={(e) =>{
                          const inputValue = e.target.value;
                            if (/^\d*\.?\d*$/.test(inputValue)) {
                           setCustomVisitorNovWeekend(inputValue)
                            }}
                          }
                      />
                    </td>
                    <td>
                      <input
                        type="text"
                        className="modal-input"
                        value={customVisitorDecWeekend}
                        onChange={(e) =>{
                          const inputValue = e.target.value;
                            if (/^\d*\.?\d*$/.test(inputValue)) {
                          setCustomVisitorDecWeekend(inputValue)
                            }}
                        }
                      />
                    </td>
                    <td>
                      <input
                        type="text"
                        className="modal-input"
                        value={customVisitorLateDecWeekend}
                        onChange={(e) =>{
                          const inputValue = e.target.value;
                            if (/^\d*\.?\d*$/.test(inputValue)) {
                           setCustomVisitorLateDecWeekend(inputValue)
                            }}
                          }
                      />
                    </td>
                    
                    {/* Repeat for other months */}
                  </tr>
                  {/* Weekend Employee Row */}
                  <tr>
                    <td>{customCategoryCopyWeekend?.parkers?.weekend_employee || 0}</td>
                    <td>
                      <input
                        type="text"
                        className="modal-input"
                        value={customEmployeeJanWeekend}
                        onChange={(e) =>{
                          const inputValue = e.target.value;
                            if (/^\d*\.?\d*$/.test(inputValue)) {
                           setCustomEmployeeJanWeekend(inputValue)
                            }}
                          }
                      />
                    </td>
                    <td>
                      <input
                        type="text"
                        className="modal-input"
                        value={customEmployeeFebWeekend}
                        onChange={(e) =>{
                          const inputValue = e.target.value;
                            if (/^\d*\.?\d*$/.test(inputValue)) {
                           setCustomEmployeeFebWeekend(inputValue)}
                            }}
                      />
                    </td>
                    <td>
                      <input
                        type="text"
                        className="modal-input"
                        value={customEmployeeMarWeekend}
                        onChange={(e) =>{
                          const inputValue = e.target.value;
                            if (/^\d*\.?\d*$/.test(inputValue)) {
                           setCustomEmployeeMarWeekend(inputValue)
                            }}
                          }
                      />
                    </td>
                    <td>
                      <input
                        type="text"
                        className="modal-input"
                        value={customEmployeeAprWeekend}
                        onChange={(e) => {
                          const inputValue = e.target.value;
                            if (/^\d*\.?\d*$/.test(inputValue)) {
                          setCustomEmployeeAprWeekend(inputValue)
                            }}
                        }
                      />
                    </td>
                    <td>
                      <input
                        type="text"
                        className="modal-input"
                        value={customEmployeeMayWeekend}
                        onChange={(e) =>{
                          const inputValue = e.target.value;
                            if (/^\d*\.?\d*$/.test(inputValue)) {
                           setCustomEmployeeMayWeekend(inputValue)
                            }}
                          }
                      />
                    </td>
                    <td>
                      <input
                        type="text"
                        className="modal-input"
                        value={customEmployeeJunWeekend}
                        onChange={(e) =>{
                          const inputValue = e.target.value;
                            if (/^\d*\.?\d*$/.test(inputValue)) {
                           setCustomEmployeeJunWeekend(inputValue)
                            }}
                          }
                      />
                    </td>
                    <td>
                      <input
                        type="text"
                        className="modal-input"
                        value={customEmployeeJulWeekend}
                        onChange={(e) =>{
                          const inputValue = e.target.value;
                            if (/^\d*\.?\d*$/.test(inputValue)) {
                           setCustomEmployeeJulWeekend(inputValue)
                        }}
                          }
                      />
                    </td>
                    <td>
                      <input
                        type="text"
                        className="modal-input"
                        value={customEmployeeAugWeekend}
                        onChange={(e) =>{
                          const inputValue = e.target.value;
                            if (/^\d*\.?\d*$/.test(inputValue)) {
                           setCustomEmployeeAugWeekend(inputValue)
                            }}
                          }
                      />
                    </td>
                    <td>
                      <input
                        type="text"
                        className="modal-input"
                        value={customEmployeeSepWeekend}
                        onChange={(e) =>{
                          const inputValue = e.target.value;
                            if (/^\d*\.?\d*$/.test(inputValue)) {
                           setCustomEmployeeSepWeekend(inputValue)
                            }}
                          }
                      />
                    </td>
                    <td>
                      <input
                        type="text"
                        className="modal-input"
                        value={customEmployeeOctWeekend}
                        onChange={(e) =>{
                          const inputValue = e.target.value;
                            if (/^\d*\.?\d*$/.test(inputValue)) {
                           setCustomEmployeeOctWeekend(inputValue)
                        }}
                          }
                      />
                    </td>
                    <td>
                      <input
                        type="text"
                        className="modal-input"
                        value={customEmployeeNovWeekend}
                        onChange={(e) => {
                          const inputValue = e.target.value;
                            if (/^\d*\.?\d*$/.test(inputValue)) {
                          setCustomEmployeeNovWeekend(inputValue)
                            }}
                        }
                      />
                    </td>
                    <td>
                      <input
                        type="text"
                        className="modal-input"
                        value={customEmployeeDecWeekend}
                        onChange={(e) =>{
                          const inputValue = e.target.value;
                            if (/^\d*\.?\d*$/.test(inputValue)) {
                           setCustomEmployeeDecWeekend(inputValue)
                            }}
                          }
                      />
                    </td>
                    <td>
                      <input
                        type="text"
                        className="modal-input"
                        value={customEmployeeLateDecWeekend}
                        onChange={(e) =>{
                          const inputValue = e.target.value;
                            if (/^\d*\.?\d*$/.test(inputValue)) {
                           setCustomEmployeeLateDecWeekend(inputValue)
                            }}
                          }
                      />
                    </td>
                    {/* Repeat for other months */}
                  </tr>
                </>
              ) : null
            ) : customCategory?.montly_ratio?.length > 0 ? (
              customCategory.montly_ratio.map((ratio, index) => (
                <tr key={index} className="text-center">
                  <td>{ratio?.parker || 0}</td>
                  <td>{ratio?.jan || 0}</td>
                  <td>{ratio?.feb || 0}</td>
                  <td>{ratio?.mar || 0}</td>
                  <td>{ratio?.apr || 0}</td>
                  <td>{ratio?.may || 0}</td>
                  <td>{ratio?.jun || 0}</td>
                  <td>{ratio?.jul || 0}</td>
                  <td>{ratio?.aug || 0}</td>
                  <td>{ratio?.sep || 0}</td>
                  <td>{ratio?.oct || 0}</td>
                  <td>{ratio?.nov || 0}</td>
                  <td>{ratio?.dec || 0}</td>
                  <td>{ratio?.late_dec || 0}</td>
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan="14">No data available</td>
              </tr>
            )}
              
            </tbody>
          </table>
        </div>
      ),
    },
    {
      key: "3",
      label: "Hourly Ratio",
      children: (
        <div className="table-responsive">
          <table className="table table-dark base-ratio-table pb-0 mb-0">
            <tbody>
              <tr className="text-center">
                <td></td>
                <td>6AM</td>
                <td>7AM</td>
                <td>8AM</td>
                <td>9AM</td>
                <td>10AM</td>
                <td>11AM</td>
                <td>12PM</td>
                <td>1PM</td>
                <td>2PM</td>
                <td>3PM</td>
                <td>4PM</td>
                <td>5PM</td>
                <td>6PM</td>
                <td>7PM</td>
                <td>8PM</td>
                <td>9PM</td>
                <td>10PM</td>
                <td>11PM</td>
                <td>12AM</td>
              </tr>
              {/* {customCategory?.time_variance?.length > 0 ? (
                customCategory.time_variance.map((ratio, index) => (
                  <tr key={index} className="text-center">
                    <td>{ratio?.parker || 0}</td>
                    <td>{ratio?.["6AM"] || 0}</td>
                    <td>{ratio?.["7AM"] || 0}</td>
                    <td>{ratio?.["8AM"] || 0}</td>
                    <td>{ratio?.["9AM"] || 0}</td>
                    <td>{ratio?.["10AM"] || 0}</td>
                    <td>{ratio?.["11AM"] || 0}</td>
                    <td>{ratio?.["12PM"] || 0}</td>
                    <td>{ratio?.["1PM"] || 0}</td>
                    <td>{ratio?.["2PM"] || 0}</td>
                    <td>{ratio?.["3PM"] || 0}</td>
                    <td>{ratio?.["4PM"] || 0}</td>
                    <td>{ratio?.["5PM"] || 0}</td>
                    <td>{ratio?.["6PM"] || 0}</td>
                    <td>{ratio?.["7PM"] || 0}</td>
                    <td>{ratio?.["8PM"] || 0}</td>
                    <td>{ratio?.["9PM"] || 0}</td>
                    <td>{ratio?.["10PM"] || 0}</td>
                    <td>{ratio?.["11PM"] || 0}</td>
                    <td>{ratio?.["12AM"] || 0}</td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan="14">No data available</td>
                </tr>
              )} */}

              {isEditMode ? (
              activeTable === "weekday" ? (
              <>

              {
                visitorInputs.map((visitor, rowIndex) => (
                  <tr key={visitor.id}>
                    {/* Parker column */}
                    <td>{visitor.parker}</td>

                    {/* Render columns in fixed order */}
                    {columnKeys.map((key, colIndex) => (
                      <td key={colIndex}>
                        <input
                          type="text"
                          className="modal-input"
                          value={visitor.data[key] || 0 } // Default value if key is missing
                          onChange={(e) =>{
                            const inputValue = e.target.value;

                            // Allow only numbers and a single decimal point
                            if (/^\d*\.?\d*$/.test(inputValue)) {
                            handleInputChange(visitor.id, key, inputValue)
                            }}
                          
                          }
                        />
                      </td>
                    ))}
                  </tr>
                ))}

              {
                employeeInputs.map((employee, rowIndex) => (
                  <tr key={employee.id}>
                    {/* Parker column */}
                    <td>{employee.parker}</td>

                    {/* Render columns in fixed order */}
                    {columnKeys.map((key, colIndex) => (
                      <td key={colIndex}>
                        <input
                          type="text"
                          className="modal-input"
                          value={employee.data[key] || 0} // Default value if key is missing
                          onChange={(e) =>{
                            const inputValue = e.target.value;

                            // Allow only numbers and a single decimal point
                            if (/^\d*\.?\d*$/.test(inputValue)) {
                            handleEmployeeInputChange(employee.id, key, inputValue)
                            }}
                          }
                        />
                      </td>
                    ))}
                  </tr>
                ))}


              
              </>
              ) : activeTable === "weekend" ? (
                <>
                {
                visitorInputsWeekend.map((visitor, rowIndex) => (
                  <tr key={visitor.id}>
                    {/* Parker column */}
                    <td>{visitor.parker}</td>

                    {/* Render columns in fixed order */}
                    {columnKeys.map((key, colIndex) => (
                      <td key={colIndex}>
                        <input
                          type="text"
                          className="modal-input"
                          value={visitor.data[key] || 0 } // Default value if key is missing
                          onChange={(e) =>{
                            const inputValue = e.target.value;

                            // Allow only numbers and a single decimal point
                            if (/^\d*\.?\d*$/.test(inputValue)) {
                            handleInputChangeWeekend(visitor.id, key, inputValue)
                            }}
                          }
                        />
                      </td>
                    ))}
                  </tr>
                ))}

              {
                employeeInputsWeekend.map((employee, rowIndex) => (
                  <tr key={employee.id}>
                    {/* Parker column */}
                    <td>{employee.parker}</td>

                    {/* Render columns in fixed order */}
                    {columnKeys.map((key, colIndex) => (
                      <td key={colIndex}>
                        <input
                          type="text"
                          className="modal-input"
                          value={employee.data[key] ||  0 } // Default value if key is missing
                          onChange={(e) =>{
                            const inputValue = e.target.value;

                            // Allow only numbers and a single decimal point
                            if (/^\d*\.?\d*$/.test(inputValue)) {
                            handleEmployeeInputChangeWeekend(employee.id, key, inputValue)
                          }}
                          
                          }
                        />
                      </td>
                    ))}
                  </tr>
              ))}
                </>
                ) : null
            ) : 
            // customCategory?.time_variance?.length > 0 ? (
              // customCategory.time_variance.map((ratio, index) => (
                customCategory?.time_variance?.length > 0 ? (
                  <>
                {customCategory.time_variance.filter((entry)=>entry.parker === "Visitor/Customer").map((ratio, index) =>(
                <tr key={index} className="text-center">
                  <td>
                    {ratio?.parker || ""}
                    {customCategory.category_flag === true ?(
                      <>
                    {ratio?.time_of_day ? ` (${ratio.time_of_day})` : ""}
                    </>
                  ): "" }
                    </td>
                  <td>{ratio?.["6AM"] || 0}</td>
                  <td>{ratio?.["7AM"] || 0}</td>
                  <td>{ratio?.["8AM"] || 0}</td>
                  <td>{ratio?.["9AM"] || 0}</td>
                  <td>{ratio?.["10AM"] || 0}</td>
                  <td>{ratio?.["11AM"] || 0}</td>
                  <td>{ratio?.["12PM"] || 0}</td>
                  <td>{ratio?.["1PM"] || 0}</td>
                  <td>{ratio?.["2PM"] || 0}</td>
                  <td>{ratio?.["3PM"] || 0}</td>
                  <td>{ratio?.["4PM"] || 0}</td>
                  <td>{ratio?.["5PM"] || 0}</td>
                  <td>{ratio?.["6PM"] || 0}</td>
                  <td>{ratio?.["7PM"] || 0}</td>
                  <td>{ratio?.["8PM"] || 0}</td>
                  <td>{ratio?.["9PM"] || 0}</td>
                  <td>{ratio?.["10PM"] || 0}</td>
                  <td>{ratio?.["11PM"] || 0}</td>
                  <td>{ratio?.["12AM"] || 0}</td>
                </tr>
            
              ))}

              {/* Employee Rows */}
              {customCategory.time_variance
                .filter((entry) => entry.parker === "Employee")
                .map((ratio, index) => (
                  <tr key={index} className="text-center">
                    <td>
                      {ratio?.parker || ""}
                      </td>
                    <td>{ratio?.["6AM"] || 0}</td>
                    <td>{ratio?.["7AM"] || 0}</td>
                    <td>{ratio?.["8AM"] || 0}</td>
                    <td>{ratio?.["9AM"] || 0}</td>
                    <td>{ratio?.["10AM"] || 0}</td>
                    <td>{ratio?.["11AM"] || 0}</td>
                    <td>{ratio?.["12PM"] || 0}</td>
                    <td>{ratio?.["1PM"] || 0}</td>
                    <td>{ratio?.["2PM"] || 0}</td>
                    <td>{ratio?.["3PM"] || 0}</td>
                    <td>{ratio?.["4PM"] || 0}</td>
                    <td>{ratio?.["5PM"] || 0}</td>
                    <td>{ratio?.["6PM"] || 0}</td>
                    <td>{ratio?.["7PM"] || 0}</td>
                    <td>{ratio?.["8PM"] || 0}</td>
                    <td>{ratio?.["9PM"] || 0}</td>
                    <td>{ratio?.["10PM"] || 0}</td>
                    <td>{ratio?.["11PM"] || 0}</td>
                    <td>{ratio?.["12AM"] || 0}</td>
                  </tr>
                ))}
                </>
              
            ) 
            : (
              <tr>
                <td colSpan="14">No data available</td>
              </tr>
            )}
              
            </tbody>
          </table>
        </div>
      ),
    },
    {
      key: "4",
      label: "Captive Ratio",
      children: (
        <div className="table-responsive">
          <table className="table table-dark base-ratio-table pb-0 mb-0">
            <tbody>
            <tr className="text-center">
                <td></td>
                <td>Daytime</td>
                <td>Evening</td>
              </tr>
              <tr >
                <td>
                  {customCategoryCopyWeekday?.data?.length > 0
                  ? activeTable === "weekday"
                    ? customCategoryCopyWeekday.parkers?.weekday_visitor
                    : customCategoryCopyWeekend.parkers?.weekend_visitor
                  : 0}
                  </td>
                {/* <td className="text-center">
                  {isEditMode ? (
                    <input
                      type="text"
                      className="modal-input"
                      value={customVisitorDaytimeEditCaptiveRatio}
                      onChange={(e) => setCustomVisitorDaytimeEditCaptiveRatio(e.target.value)}
                    />
                  ) : customCategory?.data?.length > 0
                  ? activeTable === "weekday"
                    ? customCategory.data[0]?.daytime_weekday_visitor_captive_ratio
                    : customCategory.data[0]?.daytime_weekend_visitor_captive_ratio
                  : 0}
            
                  </td> */}
                  {/* // */}

                  <td className="text-center">
                  {customCategoryCopyWeekday?.data?.length && customCategoryCopyWeekend?.data?.length > 0 ? (
                    isEditMode ? (
                      <input
                        type="text"
                        className="modal-input"
                        value={
                          activeTable === "weekday"
                            ? customVisitorDaytimeCaptiveRatio
                            : customVisitorDaytimeCaptiveRatioWeekend
                        }
                        onChange={(e) =>{
                          const inputValue = e.target.value;
                            if (/^\d*\.?\d*$/.test(inputValue)) {
                          activeTable === "weekday"
                            ? setCustomVisitorDaytimeCaptiveRatio(inputValue)
                            : setCustomVisitorDaytimeCaptiveRatioWeekend(inputValue)
                            }}
                        }
                      />
                    ) : activeTable === "weekday" ? (
                      customCategoryCopyWeekday.data[0]?.daytime_weekday_visitor_captive_ratio
                    ) : (
                      customCategoryCopyWeekend.data[0]?.daytime_weekend_visitor_captive_ratio
                    )
                  ) : (
                    0
                  )}
              </td>
                
                {/* // */}
                {/* <td className="text-center">
                {customCategory?.data?.length > 0
                  ? activeTable === "weekday"
                    ? customCategory.data[0].evening_weekday_visitor_captive_ratio
                    : customCategory.data[0].evening_weekend_visitor_captive_ratio
                  : 0}
                </td> */}
                {/* // */}

                <td className="text-center">
                  {customCategoryCopyWeekday?.data?.length && customCategoryCopyWeekend?.data?.length > 0 ? (
                    isEditMode ? (
                      <input
                        type="text"
                        className="modal-input"
                        value={
                          activeTable === "weekday"
                            ? customVisitorEveningCaptiveRatio
                            : customVisitorEveningCaptiveRatioWeekend
                            
                        }
                        onChange={(e) =>{
                          const inputValue = e.target.value;
                            if (/^\d*\.?\d*$/.test(inputValue)) {
                          activeTable === "weekday"
                            ? setCustomVisitorEveningCaptiveRatio(inputValue)
                            : setCustomVisitorEveningCaptiveRatioWeekend(inputValue)
                            }}
                        }
                      />
                    ) : activeTable === "weekday" ? (
                      customCategoryCopyWeekday.data[0].evening_weekday_visitor_captive_ratio
                    ) : (
                      customCategoryCopyWeekend.data[0].evening_weekend_visitor_captive_ratio
                    )
                  ) : (
                    0
                  )}
              </td>

              </tr>
              <tr>
                <td>
                  {/* Employee */}
                  {customCategoryCopyWeekday?.data?.length > 0
                  ? activeTable === "weekday"
                    ? customCategoryCopyWeekday.parkers?.weekday_employee
                    : customCategoryCopyWeekend.parkers?.weekend_employee
                  : 0}
                  
                  </td>
                <td className="text-center">
                {/* {customCategory?.data?.length > 0
                  ? activeTable === "weekday"
                    ? customCategory.data[0].daytime_weekday_employee_captive_ratio
                    : customCategory.data[0].daytime_weekend_employee_captive_ratio
                  : 0} */}

                  {/* // */}

                  {customCategoryCopyWeekday?.data?.length && customCategoryCopyWeekend?.data?.length > 0 ? (
                    isEditMode ? (
                      <input
                        type="text"
                        className="modal-input"
                        value={
                          activeTable === "weekday"
                            ? customEmployeeDaytimeCaptiveRatio
                            : customEmployeeDaytimeCaptiveRatioWeekend
                            
                        }
                        onChange={(e) =>{
                          const inputValue = e.target.value;
                            if (/^\d*\.?\d*$/.test(inputValue)) {
                          activeTable === "weekday"
                            ? setCustomEmployeeDaytimeCaptiveRatio(inputValue)
                            : setCustomEmployeeDaytimeCaptiveRatioWeekend(inputValue)
                            }}
                        }
                      />
                    ) : activeTable === "weekday" ? (
                      customCategoryCopyWeekday.data[0].daytime_weekday_employee_captive_ratio
                    ) : (
                      customCategoryCopyWeekend.data[0].daytime_weekend_employee_captive_ratio
                    )
                  ) : (
                    0
                  )}
                </td>
                <td className="text-center">
                {/* {customCategory?.data?.length > 0
                  ? activeTable === "weekday"
                    ? customCategory.data[0].evening_weekday_employee_captive_ratio
                    : customCategory.data[0].evening_weekend_employee_captive_ratio
                  : 0} */}

                  {/* // */}

                  {customCategoryCopyWeekday?.data?.length && customCategoryCopyWeekend?.data?.length > 0 ? (
                    isEditMode ? (
                      <input
                        type="text"
                        className="modal-input"
                        value={
                          activeTable === "weekday"
                            ? customEmployeeEveningCaptiveRatio
                            : customEmployeeEveningCaptiveRatioWeekend
                            
                        }
                        onChange={(e) =>{
                          const inputValue = e.target.value;
                            if (/^\d*\.?\d*$/.test(inputValue)) {
                          activeTable === "weekday"
                            ? setCustomEmployeeEveningCaptiveRatio(inputValue)
                            : setCustomEmployeeEveningCaptiveRatioWeekend(inputValue)
                            }}
                        }
                      />
                    ) : activeTable === "weekday" ? (
                      customCategoryCopyWeekday.data[0].evening_weekday_employee_captive_ratio
                    ) : (
                      customCategoryCopyWeekend.data[0].evening_weekend_employee_captive_ratio
                    )
                  ) : (
                    0
                  )}


                </td>
              </tr>
            </tbody>
          </table>
        </div>
      ),
    },
    {
      key: "5",
      label: "Driving Adjustment",
      children: (
        <div className="table-responsive">
          <table className="table table-dark base-ratio-table pb-0 mb-0">
            <tbody>
              <tr className="text-center">
                <td></td>
                <td>Daytime</td>
                <td>Evening</td>
              </tr>
              <tr>
                <td>
                  {/* Visitor */}
                  {customCategory?.data?.length > 0
                  ? activeTable === "weekday"
                    ? customCategory.parkers?.weekday_visitor
                    : customCategory.parkers?.weekend_visitor
                  : 0}
                  
                  </td>
                <td className="text-center">
                  {/* {customCategory?.data?.length > 0
                  ? activeTable === "weekday"
                    ? customCategory.data[0].daytime_weekday_visitor_driving_adjustment
                    : customCategory.data[0].daytime_weekend_visitor_driving_adjustment
                  : 0} */}

                  {/* // */}

                  {customCategoryCopyWeekday?.data?.length && customCategoryCopyWeekend?.data?.length > 0 ? (
                    isEditMode ? (
                      <input
                        type="text"
                        className="modal-input"
                        value={
                          activeTable === "weekday"
                            ? customVisitorDaytimeDrivingRatio
                            : customVisitorDaytimeDrivingRatioWeekend
                            
                        }
                        onChange={(e) =>{
                          const inputValue = e.target.value;
                            if (/^\d*\.?\d*$/.test(inputValue)) {
                          activeTable === "weekday"
                            ? setCustomVisitorDaytimeDrivingRatio(inputValue)
                            : setCustomVisitorDaytimeDrivingRatioWeekend(inputValue)
                            }}
                        }
                      />
                    ) : activeTable === "weekday" ? (
                      customCategoryCopyWeekday.data[0].daytime_weekday_visitor_driving_adjustment
                    ) : (
                      customCategoryCopyWeekend.data[0].daytime_weekend_visitor_driving_adjustment
                    )
                  ) : (
                    0
                  )}
                  </td>
                <td className="text-center">
                {/* {customCategory?.data?.length > 0
                  ? activeTable === "weekday"
                    ? customCategory.data[0].evening_weekday_visitor_driving_adjustment
                    : customCategory.data[0].evening_weekend_visitor_driving_adjustment
                  : 0} */}

                  {/* // */}

                  {customCategoryCopyWeekday?.data?.length && customCategoryCopyWeekend?.data?.length > 0 ? (
                    isEditMode ? (
                      <input
                        type="text"
                        className="modal-input"
                        value={
                          activeTable === "weekday"
                            ? customVisitorEveningDrivingRatio
                            : customVisitorEveningDrivingRatioWeekend
                            
                        }
                        onChange={(e) =>{
                          const inputValue = e.target.value;
                            if (/^\d*\.?\d*$/.test(inputValue)) {
                          activeTable === "weekday"
                            ? setCustomVisitorEveningDrivingRatio(inputValue)
                            : setCustomVisitorEveningDrivingRatioWeekend(inputValue)
                            }}
                        }
                      />
                    ) : activeTable === "weekday" ? (
                      customCategoryCopyWeekday.data[0].evening_weekday_visitor_driving_adjustment
                    ) : (
                      customCategoryCopyWeekend.data[0].evening_weekend_visitor_driving_adjustment
                    )
                  ) : (
                    0
                  )}
                </td>
              </tr>
              <tr>
                <td>
                  {/* Employee */}
                  {customCategory?.data?.length > 0
                  ? activeTable === "weekday"
                    ? customCategory.parkers?.weekday_employee
                    : customCategory.parkers?.weekend_employee
                  : 0}
                  
                  </td>
                <td className="text-center">
                {/* {customCategory?.data?.length > 0
                  ? activeTable === "weekday"
                    ? customCategory.data[0].daytime_weekday_employee_driving_adjustment
                    : customCategory.data[0].daytime_weekend_employee_driving_adjustment
                  : 0} */}

                  {/* // */}

                  {customCategoryCopyWeekday?.data?.length && customCategoryCopyWeekend?.data?.length > 0 ? (
                    isEditMode ? (
                      <input
                        type="text"
                        className="modal-input"
                        value={
                          activeTable === "weekday"
                            ? customEmployeeDaytimeDrivingRatio
                            : customEmployeeDaytimeDrivingRatioWeekend
                            
                        }
                        onChange={(e) =>{
                          const inputValue = e.target.value;
                            if (/^\d*\.?\d*$/.test(inputValue)) {
                          activeTable === "weekday"
                            ? setCustomEmployeeDaytimeDrivingRatio(inputValue)
                            : setCustomEmployeeDaytimeDrivingRatioWeekend(inputValue)
                            }}
                        }
                      />
                    ) : activeTable === "weekday" ? (
                      customCategoryCopyWeekday.data[0].daytime_weekday_employee_driving_adjustment
                    ) : (
                      customCategoryCopyWeekend.data[0].daytime_weekend_employee_driving_adjustment
                    )
                  ) : (
                    0
                  )}



                </td>
                <td className="text-center">
                {/* {customCategory?.data?.length > 0
                  ? activeTable === "weekday"
                    ? customCategory.data[0].evening_weekday_visitor_driving_adjustment
                    : customCategory.data[0].evening_weekend_visitor_driving_adjustment
                  : 0} */}

                  {/* // */}

                  {customCategoryCopyWeekday?.data?.length && customCategoryCopyWeekend?.data?.length > 0 ? (
                    isEditMode ? (
                      <input
                        type="text"
                        className="modal-input"
                        value={
                          activeTable === "weekday"
                            ? customEmployeeEveningDrivingRatio
                            : customEmployeeEveningDrivingRatioWeekend
                            
                        }
                        onChange={(e) =>{
                          const inputValue = e.target.value;
                            if (/^\d*\.?\d*$/.test(inputValue)) {
                          activeTable === "weekday"
                            ? setCustomEmployeeEveningDrivingRatio(inputValue)
                            : setCustomEmployeeEveningDrivingRatioWeekend(inputValue)
                            }}
                        }
                      />
                    ) : activeTable === "weekday" ? (
                      customCategoryCopyWeekday.data[0].evening_weekday_employee_driving_adjustment
                    ) : (
                      customCategoryCopyWeekend.data[0].evening_weekend_employee_driving_adjustment
                    )
                  ) : (
                    0
                  )}

                </td>
              </tr>
            </tbody>
          </table>
        </div>
      ),
    },
  ];

  // Tab items configuration
  // const itemsWeekend = [
  //   {
  //     key: "1",
  //     label: "Base Ratio",
  //     children: (
  //       <table className="table table-dark base-ratio-table pb-0 mb-0">
  //         <tbody>
  //           <tr>
  //             <td style={{ width: "30%" }}>Visitor</td>
  //             <td>13.25</td>
  //           </tr>
  //           <tr>
  //             <td style={{ width: "30%" }}>Employee</td>
  //             <td>2.25</td>
  //           </tr>
  //           <tr>
  //             <td style={{ width: "30%" }}>Total</td>
  //             <td>15.50</td>
  //           </tr>
  //         </tbody>
  //       </table>
  //     ),
  //   },
  //   {
  //     key: "2",
  //     label: "Captive Ratio",
  //     children: (
  //       <table className="table table-dark base-ratio-table pb-0 mb-0">
  //         <tbody>
  //           <tr>
  //             <td></td>
  //             <td>Jan</td>
  //             <td>Feb</td>
  //             <td>Mar</td>
  //             <td>Apr</td>
  //             <td>May</td>
  //             <td>Jun</td>
  //             <td>Jul</td>
  //             <td>Aug</td>
  //             <td>Sep</td>
  //             <td>Oct</td>
  //             <td>Nov</td>
  //             <td>Dec</td>
  //             <td>Last Dec</td>
  //           </tr>
  //           <tr>
  //             <td>Visitor</td>
  //             <td>88%</td>
  //             <td>87%</td>
  //             <td>98%</td>
  //             <td>87%</td>
  //             <td>87%</td>
  //             <td>87%</td>
  //             <td>87%</td>
  //             <td>87%</td>
  //             <td>87%</td>
  //             <td>87%</td>
  //             <td>87%</td>
  //             <td>87%</td>
  //             <td>87%</td>
  //           </tr>
  //           <tr>
  //             <td>Employee</td>
  //             <td>88%</td>
  //             <td>87%</td>
  //             <td>98%</td>
  //             <td>87%</td>
  //             <td>87%</td>
  //             <td>87%</td>
  //             <td>87%</td>
  //             <td>87%</td>
  //             <td>87%</td>
  //             <td>87%</td>
  //             <td>87%</td>
  //             <td>87%</td>
  //             <td>87%</td>
  //           </tr>
  //         </tbody>
  //       </table>
  //     ),
  //   },
  //   {
  //     key: "3",
  //     label: "Hourly Ratio",
  //     children: (
  //       <table className="table table-dark base-ratio-table pb-0 mb-0">
  //         <tbody>
  //           <tr>
  //             <td></td>
  //             <td>6AM</td>
  //             <td>7AM</td>
  //             <td>8AM</td>
  //             <td>9AM</td>
  //             <td>10AM</td>
  //             <td>11AM</td>
  //             <td>12PM</td>
  //             <td>1PM</td>
  //             <td>2PM</td>
  //             <td>3PM</td>
  //             <td>4PM</td>
  //             <td>5PM</td>
  //             <td>6PM</td>
  //           </tr>
  //           <tr>
  //             <td>Visitor</td>
  //             <td>88%</td>
  //             <td>87%</td>
  //             <td>98%</td>
  //             <td>87%</td>
  //             <td>87%</td>
  //             <td>87%</td>
  //             <td>87%</td>
  //             <td>87%</td>
  //             <td>87%</td>
  //             <td>87%</td>
  //             <td>87%</td>
  //             <td>87%</td>
  //             <td>87%</td>
  //           </tr>
  //           <tr>
  //             <td>Employee</td>
  //             <td>88%</td>
  //             <td>87%</td>
  //             <td>98%</td>
  //             <td>87%</td>
  //             <td>87%</td>
  //             <td>87%</td>
  //             <td>87%</td>
  //             <td>87%</td>
  //             <td>87%</td>
  //             <td>87%</td>
  //             <td>87%</td>
  //             <td>87%</td>
  //             <td>87%</td>
  //           </tr>
  //         </tbody>
  //       </table>
  //     ),
  //   },
  //   {
  //     key: "4",
  //     label: "Captive Ratio",
  //     children: (
  //       <table className="table table-dark base-ratio-table pb-0 mb-0">
  //         <tbody>
  //           <tr>
  //             <td></td>
  //             <td></td>
  //             <td>Daytime</td>
  //             <td>Evening</td>
  //           </tr>
  //           <tr>
  //             <td>Visitor</td>
  //             <td>100%</td>
  //             <td>100%</td>
  //             <td>100%</td>
  //           </tr>
  //           <tr>
  //             <td>Employee</td>
  //             <td>100%</td>
  //             <td>100%</td>
  //             <td>100%</td>
  //           </tr>
  //         </tbody>
  //       </table>
  //     ),
  //   },
  //   {
  //     key: "5",
  //     label: "Driving Adjustment",
  //     children: (
  //       <table className="table table-dark base-ratio-table pb-0 mb-0">
  //         <tbody>
  //           <tr>
  //             <td>Employee</td>
  //             <td>100%</td>
  //           </tr>
  //           <tr>
  //             <td>Visitor</td>
  //             <td>100%</td>
  //           </tr>
  //         </tbody>
  //       </table>
  //     ),
  //   },
  // ];

  // modal collapse
  // Tab items configuration
  const tableHeaders = [
    "",
    "6AM",
    "7AM",
    "8AM",
    "9AM",
    "10AM",
    "11AM",
    "12PM",
    "1PM",
    "2PM",
    "3PM",
    "4PM",
    "5PM",
    "6PM",
    "7PM",
    "8PM",
    "9PM",
    "10PM",
    "11PM",
    "12AM",
  ];

  // let columnKeys = [
  //   "6AM", "7AM", "8AM", "9AM", "10AM", "11AM", "12PM",
  //   "1PM", "2PM", "3PM", "4PM", "5PM", "6PM", "7PM", 
  //   "8PM", "9PM", "10PM", "11PM", "12AM"
  // ];

 

  const handleInputChange = (id, key, value) => {
    setVisitorInputs((prev) =>
      prev.map((visitor) =>
        visitor.id === id
          ? {
              ...visitor,
              // data: { ...visitor.data, [key]: value }, 
              // data: { ...visitor.data, [key]: isNaN(value) ? value : parseFloat(value) },
              data: { 
                ...visitor.data, 
                [key]: value // Store the raw value to preserve intermediate states
              },
            }
          : visitor
      )
    );
  };
  console.log("visitorInputs after change on field::",visitorInputs);

  const handleInputChangeWeekend = (id, key, value) => {
    setVisitorInputsWeekend((prev) =>
      prev.map((visitor) =>
        visitor.id === id
          ? {
              ...visitor,
              // data: { ...visitor.data, [key]: value }, 
              // data: { ...visitor.data, [key]: isNaN(value) ? value : Number(value) },
              data: { 
                ...visitor.data, 
                [key]: value // Store the raw value to preserve intermediate states
              },
            }
          : visitor
      )
    );
  };

  const handleEmployeeInputChange = (id, key, value) => {
    setEmployeeInputs((prev) =>
      prev.map((employee) =>
        employee.id === id
          ? {
              ...employee,
              // data: { ...visitor.data, [key]: value }, 
              // data: { ...employee.data, [key]: isNaN(value) ? value : Number(value) },
              data: { 
                ...employee.data, 
                [key]: value // Store the raw value to preserve intermediate states
              },
            }
          : employee
      )
    );
  };
  console.log("employee after change on field::",employeeInputs);

  const handleEmployeeInputChangeWeekend = (id, key, value) => {
    setEmployeeInputsWeekend((prev) =>
      prev.map((employee) =>
        employee.id === id
          ? {
              ...employee,
              // data: { ...visitor.data, [key]: value }, 
              // data: { ...employee.data, [key]: isNaN(value) ? value : Number(value) },
              data: { 
                ...employee.data, 
                [key]: value // Store the raw value to preserve intermediate states
              },
            }
          : employee
      )
    );
  };



  const itemsModal = [
    {
      key: "1",
      label: "Base Ratio",
      children: (
        <div className="table-responsive">
          <table className="table table-dark base-ratio-table pb-0 mb-0">
            <tbody>
              <tr>
                <td style={{ width: "30%" }}>
                  {/* Visitor */}
                  {customCategoryCopyWeekday?.data?.length > 0
                  ? activeTableModal === "weekday"
                    ? customCategoryCopyWeekday.parkers?.weekday_visitor
                    : customCategory.parkers?.weekend_visitor
                  : 0}
                  </td>
                <td>
                  <input type="text" className="modal-input" 
                  value={customVistorBaseRatio} 
                  onChange={(e)=>{
                    const inputValue = e.target.value;
                    if (/^\d*\.?\d*$/.test(inputValue)) {
                    setCustomVistorBaseRatio(inputValue)
                    }}
                  } 
                  />
                </td>
              </tr>
              <tr>
                <td style={{ width: "30%" }}>
                  {/* Employee */}
                  {customCategoryCopyWeekday?.data?.length > 0
                  ? activeTableModal === "weekday"
                    ? customCategoryCopyWeekday.parkers?.weekday_employee
                    : customCategory.parkers?.weekend_employee
                  : 0}
                  </td>
                <td>
                  <input type="text" 
                  className="modal-input"
                  value={customEmployeeBaseRatio} 
                  onChange={(e)=>{
                    const inputValue = e.target.value;
                    if (/^\d*\.?\d*$/.test(inputValue)) {
                    setCustomEmployeeBaseRatio(inputValue)
                    }}
                }
                  
                  />
                </td>
              </tr>
              {/* <tr>
                <td style={{ width: "30%" }}>Total</td>
                <td>
                  <input type="text" className="modal-input" value="15.25" />
                </td>
              </tr> */}
            </tbody>
          </table>
        </div>
      ),
    },
    {
      key: "2",
      label: "Monthly Ratio",
      children: (
        <div className="table-responsive">
          <table className="table table-dark base-ratio-table pb-0 mb-0">
            <tbody>
              <tr className="text-center">
                <td></td>
                <td>Jan</td>
                <td>Feb</td>
                <td>Mar</td>
                <td>Apr</td>
                <td>May</td>
                <td>Jun</td>
                <td>Jul</td>
                <td>Aug</td>
                <td>Sep</td>
                <td>Oct</td>
                <td>Nov</td>
                <td>Dec</td>
                <td>Late Dec</td>
              </tr>
              <tr>
                <td>
                  {/* Visitor */}
                  {customCategoryCopyWeekday?.data?.length > 0
                  ? activeTableModal === "weekday"
                    ? customCategoryCopyWeekday.parkers?.weekday_visitor
                    : customCategory.parkers?.weekend_visitor
                  : 0}
                  
                  </td>
                <td>
                  <input type="text" className="modal-input" 
                  value={customVisitorJan} 
                  onChange={(e)=>{
                    const inputValue = e.target.value;
                    if (/^\d*\.?\d*$/.test(inputValue)) {
                    setCustomVisitorJan(inputValue)
                    }}
                  } 
                  />
                </td>
                <td>
                <input type="text" className="modal-input" 
                value={customVisitorFeb} 
                onChange={(e)=>{
                  const inputValue = e.target.value;
                    if (/^\d*\.?\d*$/.test(inputValue)) {
                  setCustomVisitorFeb(inputValue)
                    }}

                } />
                </td>
                <td>
                <input type="text" className="modal-input" 
                value={customVisitorMar} 
                onChange={(e)=>{
                  const inputValue = e.target.value;
                    if (/^\d*\.?\d*$/.test(inputValue)) {
                  setCustomVisitorMar(inputValue)
                    }}

                } />
                </td>
                <td>
                <input type="text" className="modal-input" 
                value={customVisitorApr} 
                onChange={(e)=>{
                  const inputValue = e.target.value;
                    if (/^\d*\.?\d*$/.test(inputValue)) {
                  setCustomVisitorApr(inputValue)
                    }}

                } 
                />
                </td>
                <td>
                <input type="text" className="modal-input" 
                value={customVisitorMay} 
                onChange={(e)=>{
                  const inputValue = e.target.value;
                    if (/^\d*\.?\d*$/.test(inputValue)) {
                  setCustomVisitorMay(inputValue)
                    }}
                } />
                </td>
                <td>
                <input type="text" className="modal-input" 
                value={customVisitorJun} 
                onChange={(e)=>{
                  const inputValue = e.target.value;
                  if (/^\d*\.?\d*$/.test(inputValue)) {
                  setCustomVisitorJun(inputValue)
                  }}

                } />
                </td>
                <td>
                <input type="text" className="modal-input" 
                value={customVisitorJul} 
                onChange={(e)=>{
                  const inputValue = e.target.value;
                    if (/^\d*\.?\d*$/.test(inputValue)) {
                  setCustomVisitorJul(inputValue)
                }}
                } />
                </td>
                <td>
                <input type="text" className="modal-input" 
                value={customVisitorAug} 
                onChange={(e)=>{
                  const inputValue = e.target.value;
                    if (/^\d*\.?\d*$/.test(inputValue)) {
                  setCustomVisitorAug(inputValue)
                    }}
                } />
                </td>
                <td>
                <input type="text" className="modal-input" 
                value={customVisitorSep} 
                onChange={(e)=>{
                  const inputValue = e.target.value;
                    if (/^\d*\.?\d*$/.test(inputValue)) {
                  setCustomVisitorSep(inputValue)
                }}
                } />
                </td>
                <td>
                <input type="text" className="modal-input" 
                value={customVisitorOct} 
                onChange={(e)=>{
                  const inputValue = e.target.value;
                    if (/^\d*\.?\d*$/.test(inputValue)) {
                  setCustomVisitorOct(inputValue)
                    }}
                } />
                </td>
                <td>
                <input type="text" className="modal-input" 
                value={customVisitorNov} 
                onChange={(e)=>{
                  const inputValue = e.target.value;
                  if (/^\d*\.?\d*$/.test(inputValue)) {
                  setCustomVisitorNov(inputValue)
                  }}

                } />
                </td>
                <td>
                <input type="text" className="modal-input" 
                value={customVisitorDec} 
                onChange={(e)=>{
                const inputValue = e.target.value;
                if (/^\d*\.?\d*$/.test(inputValue)) {
                  setCustomVisitorDec(inputValue)
                }}

                } />
                </td>
                <td>
                <input type="text" className="modal-input" 
                value={customVisitorLateDec} 
                onChange={(e)=>{
                  const inputValue = e.target.value;
                if (/^\d*\.?\d*$/.test(inputValue)) {
                setCustomVisitorLateDec(inputValue)
                }}
              
              } />
                </td>
              </tr>
              <tr>
                <td>
                  {/* Employee */}
                  {customCategoryCopyWeekday?.data?.length > 0
                  ? activeTableModal === "weekday"
                    ? customCategoryCopyWeekday.parkers?.weekday_employee
                    : customCategory.parkers?.weekend_employee
                  : 0}
                  </td>
                <td>
                  <input type="text" className="modal-input" 
                  value={customEmployeeJan} 
                  onChange={(e)=>{
                    const inputValue = e.target.value;
                if (/^\d*\.?\d*$/.test(inputValue)) {
                  setCustomEmployeeJan(inputValue)
                }}
                  
                  }/>
                </td>
                <td>
                  <input type="text" className="modal-input" 
                  value={customEmployeeFeb} 
                  onChange={(e)=>{
                    const inputValue = e.target.value;
                if (/^\d*\.?\d*$/.test(inputValue)) {
                  setCustomEmployeeFeb(inputValue)
                }}
                  
                  }/>
                </td>
                <td>
                  <input type="text" className="modal-input" 
                  value={customEmployeeMar} 
                  onChange={(e)=>{
                    const inputValue = e.target.value;
                if (/^\d*\.?\d*$/.test(inputValue)) {
                    setCustomEmployeeMar(inputValue)
                }}

                  } />
                </td>
                <td>
                  <input type="text" className="modal-input" 
                  value={customEmployeeApr} 
                  onChange={(e)=>{
                    const inputValue = e.target.value;
                if (/^\d*\.?\d*$/.test(inputValue)) {
                  setCustomEmployeeApr(e.target.value)
                }}
                  } />
                </td>
                <td>
                  <input type="text" className="modal-input" 
                  value={customEmployeeMay} 
                  onChange={(e)=>{
                    const inputValue = e.target.value;
                if (/^\d*\.?\d*$/.test(inputValue)) {
                  setCustomEmployeeMay(inputValue)
                }}
                  } />
                </td>
                <td>
                  <input type="text" className="modal-input" 
                  value={customEmployeeJun} 
                  onChange={(e)=>{
                    const inputValue = e.target.value;
                if (/^\d*\.?\d*$/.test(inputValue)) {
                    setCustomEmployeeJun(inputValue)
                }}

                  } />
                </td>
                <td>
                  <input type="text" className="modal-input" 
                  value={customEmployeeJul} 
                  onChange={(e)=>{
                    const inputValue = e.target.value;
                if (/^\d*\.?\d*$/.test(inputValue)) {
                    setCustomEmployeeJul(inputValue)
                  }}
                  } />
                </td>
                <td>
                  <input type="text" className="modal-input" 
                  value={customEmployeeAug} 
                  onChange={(e)=>{
                    const inputValue = e.target.value;
                if (/^\d*\.?\d*$/.test(inputValue)) {
                  setCustomEmployeeAug(inputValue)
                }}
                
                } />
                </td>
                <td>
                  <input type="text" className="modal-input" 
                  value={customEmployeeSep} 
                  onChange={(e)=>{
                    const inputValue = e.target.value;
                if (/^\d*\.?\d*$/.test(inputValue)) {
                  setCustomEmployeeSep(inputValue)
                }}
                } />
                </td>
                <td>
                  <input type="text" className="modal-input" 
                  value={customEmployeeOct} 
                  onChange={(e)=>{
                    const inputValue = e.target.value;
                if (/^\d*\.?\d*$/.test(inputValue)) {
                    setCustomEmployeeOct(inputValue)
                }}

                  } />
                </td>
                <td>
                  <input type="text" className="modal-input" 
                  value={customEmployeeNov} 
                  onChange={(e)=>{
                    const inputValue = e.target.value;
                if (/^\d*\.?\d*$/.test(inputValue)) {
                    setCustomEmployeeNov(inputValue)
                }}

                  } />
                </td>
                <td>
                  <input type="text" className="modal-input" 
                  value={customEmployeeDec} 
                  onChange={(e)=>{
                    const inputValue = e.target.value;
                if (/^\d*\.?\d*$/.test(inputValue)) {
                  setCustomEmployeeDec(inputValue)
                }}
                } 
                  />
                </td>
                <td>
                  <input type="text" className="modal-input" 
                  value={customEmployeeLateDec} 
                  onChange={(e)=>{
                    const inputValue = e.target.value;
                if (/^\d*\.?\d*$/.test(inputValue)) {
                  setCustomEmployeeLateDec(inputValue)
                  }}
                } />
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      ),
    },
    {
      key: "3",
      label: "Hourly Ratio",
      children: (
        <div className="table-responsive">
          <table className="table table-dark base-ratio-table pb-0 mb-0">
            <tbody>
              <tr className="text-center">
                <td></td>
                <td>6AM</td>
                <td>7AM</td>
                <td>8AM</td>
                <td>9AM</td>
                <td>10AM</td>
                <td>11AM</td>
                <td>12PM</td>
                <td>1PM</td>
                <td>2PM</td>
                <td>3PM</td>
                <td>4PM</td>
                <td>5PM</td>
                <td>6PM</td>
                <td>7PM</td>
                <td>8PM</td>
                <td>9PM</td>
                <td>10PM</td>
                <td>11PM</td>
                <td>12AM</td>
              </tr>

              {/* // */}

              {
                visitorInputs.map((visitor, rowIndex) => (
                  <tr key={visitor.id}>
                    {/* Parker column */}
                    <td>{visitor.parker}</td>

                    {/* Render columns in fixed order */}
                    {columnKeys.map((key, colIndex) => (
                      <td key={colIndex}>
                        <input
                          type="text"
                          className="modal-input"
                          value={visitor.data[key] || 0} // Default value if key is missing
                          onChange={(e) =>{
                            const inputValue = e.target.value;

                            // Allow only numbers and a single decimal point
                            if (/^\d*\.?\d*$/.test(inputValue)) {
                            handleInputChange(visitor.id, key, inputValue)
                            }}
                          }
                          // onBlur={() => {
                          //   // Convert the value to a number when the user leaves the input field
                          //   handleInputChange(visitor.id, key, parseFloat(visitor.data[key]) || 0);
                          // }}
                        />
                      </td>
                    ))}
                  </tr>
                ))}

              {
                employeeInputs.map((employee, rowIndex) => (
                  <tr key={employee.id}>
                    {/* Parker column */}
                    <td>{employee.parker}</td>

                    {/* Render columns in fixed order */}
                    {columnKeys.map((key, colIndex) => (
                      <td key={colIndex}>
                        <input
                          type="text"
                          className="modal-input"
                          value={employee.data[key] || 0} // Default value if key is missing
                          onChange={(e) =>{
                            const inputValue = e.target.value;

                            // Allow only numbers and a single decimal point
                            if (/^\d*\.?\d*$/.test(inputValue)) {
                            handleEmployeeInputChange(employee.id, key, inputValue)
                            }}
                          }
                        />
                      </td>
                    ))}
                  </tr>
                ))}

            </tbody>
          </table>
        </div>
      ),
    },
    {
      key: "4",
      label: "Captive Ratio",
      children: (
        <div className="table-responsive">
          <table className="table table-dark base-ratio-table pb-0 mb-0">
            <tbody>
              <tr>
                <td></td>
                
                <td>Daytime</td>
                <td>Evening</td>
              </tr>
              <tr>
                <td>
                  {/* Visitor */}
                  {customCategoryCopyWeekday?.data?.length > 0
                  ? activeTableModal === "weekday"
                    ? customCategoryCopyWeekday.parkers?.weekday_visitor
                    : customCategory.parkers?.weekend_visitor
                  : 0}
                  
                  </td>
               
                <td>
                  <input type="text" className="modal-input" 
                  value={customVisitorDaytimeCaptiveRatio} 
                  onChange={(e)=>{
                    const inputValue = e.target.value;
                    if (/^\d*\.?\d*$/.test(inputValue)) {
                    setCustomVisitorDaytimeCaptiveRatio(inputValue)
                    }}
                  } 
                  />
                </td>
                <td>
                  <input type="text" className="modal-input" 
                  value={customVisitorEveningCaptiveRatio} 
                  onChange={(e)=>{
                    const inputValue = e.target.value;
                    if (/^\d*\.?\d*$/.test(inputValue)) {
                    setCustomVisitorEveningCaptiveRatio(inputValue)
                    }}

                  } 
                  />
                </td>
              </tr>
              <tr>
                <td>
                  {/* Employee */}
                  {customCategoryCopyWeekday?.data?.length > 0
                  ? activeTableModal === "weekday"
                    ? customCategoryCopyWeekday.parkers?.weekday_employee
                    : customCategory.parkers?.weekend_employee
                  : 0}
                  
                  </td>
               
                <td>
                  <input type="text" className="modal-input" 
                  value={customEmployeeDaytimeCaptiveRatio} 
                  onChange={(e)=>{
                    const inputValue = e.target.value;
                    if (/^\d*\.?\d*$/.test(inputValue)) {
                    setCustomEmployeeDaytimeCaptiveRatio(inputValue)
                    }}
                  }
                  
                  />
                </td>
                <td>
                  <input type="text" className="modal-input"  
                  value={customEmployeeEveningCaptiveRatio} 
                  onChange={(e)=>{
                    const inputValue = e.target.value;
                    if (/^\d*\.?\d*$/.test(inputValue)) {
                    setCustomEmployeeEveningCaptiveRatio(inputValue)
                    }}
                }
                  />
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      ),
    },
    {
      key: "5",
      label: "Driving Adjustment",
      children: (
        <div className="table-responsive">
          <table className="table table-dark base-ratio-table pb-0 mb-0">
            <tbody>
            <tr>
                <td></td>
                <td>Daytime</td>
                <td>Evening</td>
              </tr>
              <tr>
                <td>
                  {/* Visitor */}
                  {customCategoryCopyWeekday?.data?.length > 0
                  ? activeTableModal === "weekday"
                    ? customCategoryCopyWeekday.parkers?.weekday_visitor
                    : customCategory.parkers?.weekend_visitor
                  : 0}
                  
                  </td>
                <td>
                  <input type="text" className="modal-input" 
                  value={customVisitorDaytimeDrivingRatio} 
                  onChange={(e)=>{
                    const inputValue = e.target.value;
                    if (/^\d*\.?\d*$/.test(inputValue)) {
                    setCustomVisitorDaytimeDrivingRatio(inputValue)
                    }}
                  } 
                  />
                </td>
                <td>
                  <input type="text" className="modal-input" 
                  value={customVisitorEveningDrivingRatio} 
                  onChange={(e)=>{
                    const inputValue = e.target.value;
                    if (/^\d*\.?\d*$/.test(inputValue)) {
                    setCustomVisitorEveningDrivingRatio(inputValue)
                    }}
                  } 
                  />
                </td>
              </tr>
              <tr>
                <td>
                  {/* Employee */}
                  {customCategoryCopyWeekday?.data?.length > 0
                  ? activeTableModal === "weekday"
                    ? customCategoryCopyWeekday.parkers?.weekday_employee
                    : customCategory.parkers?.weekend_employee
                  : 0}
                  
                  </td>
               
                <td>
                  <input type="text" className="modal-input" 
                  value={customEmployeeDaytimeDrivingRatio} 
                  onChange={(e)=>{
                    const inputValue = e.target.value;
                    if (/^\d*\.?\d*$/.test(inputValue)) {
                    setCustomEmployeeDaytimeDrivingRatio(inputValue)
                  }}
                }
                   />
                </td>
                <td>
                  <input type="text" className="modal-input" 
                  value={customEmployeeEveningDrivingRatio} 
                  onChange={(e)=>{
                    const inputValue = e.target.value;
                    if (/^\d*\.?\d*$/.test(inputValue)) {
                    setCustomEmployeeEveningDrivingRatio(inputValue)
                    }}
                  } 
                  />
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      ),
    },
  ];

  const onClose = () => {
    setOpen(false);
  };

  useEffect(() => {
    if (customCategoryCopyWeekday?.data?.length > 0 && customCategoryCopyWeekend?.data?.length > 0 ) {
      const weekdayData = customCategoryCopyWeekday.data[0]; // Assuming you always get one object for the current landuseID
      const weekendData = customCategoryCopyWeekend.data[0];

    
      //   setUnitList(weekdayData?.unit)
    
      
      // console.log("customCategory?.data[0]?.unit::",weekdayData?.unit);
      setEditedLandUseName(weekdayData.land_use || "")



  
      // Binding values to respective states Weekday
      setCustomVistorBaseRatio(weekdayData.weekday_visitor_base_ratio || 0);
      setCustomEmployeeBaseRatio(weekdayData.weekday_employee_base_ratio || 0);
  
      setCustomVisitorDaytimeCaptiveRatio(weekdayData.daytime_weekday_visitor_captive_ratio || 0);
      setCustomVisitorEveningCaptiveRatio(weekdayData.evening_weekday_visitor_captive_ratio || 0);
  
      setCustomEmployeeDaytimeCaptiveRatio(weekdayData.daytime_weekday_employee_captive_ratio || 0);
      setCustomEmployeeEveningCaptiveRatio(weekdayData.evening_weekday_employee_captive_ratio || 0);
  
      setCustomVisitorDaytimeDrivingRatio(weekdayData.daytime_weekday_visitor_driving_adjustment || 0);
      setCustomVisitorEveningDrivingRatio(weekdayData.evening_weekday_visitor_driving_adjustment || 0);
  
      setCustomEmployeeDaytimeDrivingRatio(weekdayData.daytime_weekday_employee_driving_adjustment || 0);
      setCustomEmployeeEveningDrivingRatio(weekdayData.evening_weekday_employee_driving_adjustment || 0);

            // Binding values to respective states Weekend
            setCustomVistorBaseRatioWeekend(weekendData.weekend_visitor_base_ratio || 0);
            setCustomEmployeeBaseRatioWeekend(weekendData.weekend_employee_base_ratio || 0);
        
            setCustomVisitorDaytimeCaptiveRatioWeekend(weekendData.daytime_weekend_visitor_captive_ratio || 0);
            setCustomVisitorEveningCaptiveRatioWeekend(weekendData.evening_weekend_visitor_captive_ratio || 0);
        
            setCustomEmployeeDaytimeCaptiveRatioWeekend(weekendData.daytime_weekend_employee_captive_ratio || 0);
            setCustomEmployeeEveningCaptiveRatioWeekend(weekendData.evening_weekend_employee_captive_ratio || 0);
        
            setCustomVisitorDaytimeDrivingRatioWeekend(weekendData.daytime_weekend_visitor_driving_adjustment || 0);
            setCustomVisitorEveningDrivingRatioWeekend(weekendData.evening_weekend_visitor_driving_adjustment || 0);
        
            setCustomEmployeeDaytimeDrivingRatioWeekend(weekendData.daytime_weekend_employee_driving_adjustment || 0);
            setCustomEmployeeEveningDrivingRatioWeekend(weekendData.evening_weekend_employee_driving_adjustment || 0);
    }
    // Bind Monthly Ratios for Visitor/Customer
    if (Array.isArray(customCategoryCopyWeekday?.montly_ratio) && customCategoryCopyWeekday.montly_ratio.length > 0) {
    const visitorMonthlyRatio = customCategoryCopyWeekday?.montly_ratio.find(
      (ratio) => ratio.parker !== "Employee"
    );

    const employeeMonthlyRatio = customCategoryCopyWeekday.montly_ratio.find(
      (ratio) => ratio.parker === "Employee"
    );


    

    if (visitorMonthlyRatio) {
      setCustomVisitorJan(visitorMonthlyRatio.jan || 0);
      setCustomVisitorFeb(visitorMonthlyRatio.feb || 0);
      setCustomVisitorMar(visitorMonthlyRatio.mar || 0);
      setCustomVisitorApr(visitorMonthlyRatio.apr || 0);
      setCustomVisitorMay(visitorMonthlyRatio.may || 0);
      setCustomVisitorJun(visitorMonthlyRatio.jun || 0);
      setCustomVisitorJul(visitorMonthlyRatio.jul || 0);
      setCustomVisitorAug(visitorMonthlyRatio.aug || 0);
      setCustomVisitorSep(visitorMonthlyRatio.sep || 0);
      setCustomVisitorOct(visitorMonthlyRatio.oct || 0);
      setCustomVisitorNov(visitorMonthlyRatio.nov || 0);
      setCustomVisitorDec(visitorMonthlyRatio.dec || 0);
      setCustomVisitorLateDec(visitorMonthlyRatio.late_dec || 0);
    } else {
      // Reset states if no visitor data is found
      setCustomVisitorJan("");
      setCustomVisitorFeb("");
      setCustomVisitorMar("");
      setCustomVisitorApr("");
      setCustomVisitorMay("");
      setCustomVisitorJun("");
      setCustomVisitorJul("");
      setCustomVisitorAug("");
      setCustomVisitorSep("");
      setCustomVisitorOct("");
      setCustomVisitorNov("");
      setCustomVisitorDec("");
      setCustomVisitorLateDec("");
    }

    if (employeeMonthlyRatio){
      setCustomEmployeeJan(employeeMonthlyRatio.jan || 0);
      setCustomEmployeeFeb(employeeMonthlyRatio.feb || 0);
      setCustomEmployeeMar(employeeMonthlyRatio.mar || 0);
      setCustomEmployeeApr(employeeMonthlyRatio.apr || 0);
      setCustomEmployeeMay(employeeMonthlyRatio.may || 0);
      setCustomEmployeeJun(employeeMonthlyRatio.jun || 0);
      setCustomEmployeeJul(employeeMonthlyRatio.jul || 0);
      setCustomEmployeeAug(employeeMonthlyRatio.aug || 0);
      setCustomEmployeeSep(employeeMonthlyRatio.sep || 0);
      setCustomEmployeeOct(employeeMonthlyRatio.oct || 0);
      setCustomEmployeeNov(employeeMonthlyRatio.nov || 0);
      setCustomEmployeeDec(employeeMonthlyRatio.dec || 0);
      setCustomEmployeeLateDec(employeeMonthlyRatio.late_dec || 0);
    }else{
      setCustomEmployeeJan("");
      setCustomEmployeeFeb("");
      setCustomEmployeeMar("");
      setCustomEmployeeApr("");
      setCustomEmployeeMay("");
      setCustomEmployeeJun("");
      setCustomEmployeeJul("");
      setCustomEmployeeAug("");
      setCustomEmployeeSep("");
      setCustomEmployeeOct("");
      setCustomEmployeeNov("");
      setCustomEmployeeDec("");
      setCustomEmployeeLateDec("");
    }
  
    if (Array.isArray(customCategoryCopyWeekend?.montly_ratio) && customCategoryCopyWeekend.montly_ratio.length > 0) {
      const visitorMonthlyRatioWeekend = customCategoryCopyWeekend?.montly_ratio.find(
        (ratio) => ratio.parker !== "Employee"
      );

      const employeeMonthlyRatio = customCategoryCopyWeekend.montly_ratio.find(
      (ratio) => ratio.parker === "Employee"
    );

    

      if (visitorMonthlyRatio) {
        setCustomVisitorJanWeekend(visitorMonthlyRatioWeekend.jan || 0);
        setCustomVisitorFebWeekend(visitorMonthlyRatioWeekend.feb || 0);
        setCustomVisitorMarWeekend(visitorMonthlyRatioWeekend.mar || 0);
        setCustomVisitorAprWeekend(visitorMonthlyRatioWeekend.apr || 0);
        setCustomVisitorMayWeekend(visitorMonthlyRatioWeekend.may || 0);
        setCustomVisitorJunWeekend(visitorMonthlyRatioWeekend.jun || 0);
        setCustomVisitorJulWeekend(visitorMonthlyRatioWeekend.jul || 0);
        setCustomVisitorAugWeekend(visitorMonthlyRatioWeekend.aug || 0);
        setCustomVisitorSepWeekend(visitorMonthlyRatioWeekend.sep || 0);
        setCustomVisitorOctWeekend(visitorMonthlyRatioWeekend.oct || 0);
        setCustomVisitorNovWeekend(visitorMonthlyRatioWeekend.nov || 0);
        setCustomVisitorDecWeekend(visitorMonthlyRatioWeekend.dec || 0);
        setCustomVisitorLateDecWeekend(visitorMonthlyRatioWeekend.late_dec || 0);
      } else {
        // Reset states if no visitor data is found
        setCustomVisitorJanWeekend("");
        setCustomVisitorFebWeekend("");
        setCustomVisitorMarWeekend("");
        setCustomVisitorAprWeekend("");
        setCustomVisitorMayWeekend("");
        setCustomVisitorJunWeekend("");
        setCustomVisitorJulWeekend("");
        setCustomVisitorAugWeekend("");
        setCustomVisitorSepWeekend("");
        setCustomVisitorOctWeekend("");
        setCustomVisitorNovWeekend("");
        setCustomVisitorDecWeekend("");
        setCustomVisitorLateDecWeekend("");
      }

      if (employeeMonthlyRatio) {
        setCustomEmployeeJanWeekend(employeeMonthlyRatio.jan || 0);
        setCustomEmployeeFebWeekend(employeeMonthlyRatio.feb || 0);
        setCustomEmployeeMarWeekend(employeeMonthlyRatio.mar || 0);
        setCustomEmployeeAprWeekend(employeeMonthlyRatio.apr || 0);
        setCustomEmployeeMayWeekend(employeeMonthlyRatio.may || 0);
        setCustomEmployeeJunWeekend(employeeMonthlyRatio.jun || 0);
        setCustomEmployeeJulWeekend(employeeMonthlyRatio.jul || 0);
        setCustomEmployeeAugWeekend(employeeMonthlyRatio.aug || 0);
        setCustomEmployeeSepWeekend(employeeMonthlyRatio.sep || 0);
        setCustomEmployeeOctWeekend(employeeMonthlyRatio.oct || 0);
        setCustomEmployeeNovWeekend(employeeMonthlyRatio.nov || 0);
        setCustomEmployeeDecWeekend(employeeMonthlyRatio.dec || 0);
        setCustomEmployeeLateDecWeekend(employeeMonthlyRatio.late_dec || 0);
      } else {
        setCustomEmployeeJanWeekend("");
        setCustomEmployeeFebWeekend("");
        setCustomEmployeeMarWeekend("");
        setCustomEmployeeAprWeekend("");
        setCustomEmployeeMayWeekend("");
        setCustomEmployeeJunWeekend("");
        setCustomEmployeeJulWeekend("");
        setCustomEmployeeAugWeekend("");
        setCustomEmployeeSepWeekend("");
        setCustomEmployeeOctWeekend("");
        setCustomEmployeeNovWeekend("");
        setCustomEmployeeDecWeekend("");
        setCustomEmployeeLateDecWeekend("");
      }
    }
  }



  if (customCategoryCopyWeekday?.time_variance?.length > 0) {
    const data = customCategoryCopyWeekday.time_variance;

    const WeekendData = customCategoryCopyWeekend.time_variance;
  
    const visitor = data.filter((item) => item.parker !== "Employee");
  
    const employee = data.filter((item) => item.parker === "Employee");

    const WeekendVisitor = WeekendData.filter((item) => item.parker !== "Employee");

    const WeekendEmployee = WeekendData.filter((item) => item.parker === "Employee");

    
    setVisitorData(visitor || []); 
    setEmployeeData(employee || []); 
    setTimeVarianceData(data); 

    setVisitorDataWeekend(WeekendVisitor || []);
    setEmployeeDataWeekend(WeekendEmployee || []);

  }
  }, [open,landuseID, customCategoryCopyWeekday,customCategoryCopyWeekend]);



  useEffect(() => {
    console.log("visitorData::",visitorData);
    setVisitorInputs([])
    setEmployeeInputs([])
    setVisitorInputsWeekend([])
    setEmployeeInputsWeekend([])

    
    if (visitorData.length > 0) {
      const initialInputs = visitorData.map((visitor,index) => ({
        id: index + 1,
        time: visitor.day_of_week,
        category:visitor.time_of_day,
        parker: visitor.parker || 0, // Default value
        data: Object.fromEntries(
          Object.entries(visitor).filter(([key]) =>
            ["6AM", "7AM", "8AM", "9AM", "10AM", "11AM", "12PM", "1PM", "2PM", "3PM", "4PM", "5PM", "6PM", "7PM", "8PM", "9PM", "10PM", "11PM", "12AM"].includes(key)
          )
        ),
      }));
      setVisitorInputs(initialInputs);
    }
      if (employeeData.length > 0) {
        const intialInputesEmployee= employeeData.map((employee,index)=>({
          id: index + 1,
          time: employee.day_of_week,
          category:employee.time_of_day,
          parker: employee.parker || 0, // Default value
          data: Object.fromEntries(
            Object.entries(employee).filter(([key]) =>
              ["6AM", "7AM", "8AM", "9AM", "10AM", "11AM", "12PM", "1PM", "2PM", "3PM", "4PM", "5PM", "6PM", "7PM", "8PM", "9PM", "10PM", "11PM", "12AM"].includes(key)
            )
          ),
        }))
        console.log("intialInputesEmployee::",intialInputesEmployee);
        setEmployeeInputs(intialInputesEmployee)
      }

      if (visitorDataWeekend.length > 0) {
        const initialInputsWeekendVisitor = visitorDataWeekend.map((visitorWeekend,index) => ({
          id: index + 1,
          time: visitorWeekend.day_of_week,
          category:visitorWeekend.time_of_day,
          parker: visitorWeekend.parker || 0,
          data: Object.fromEntries(
            Object.entries(visitorWeekend).filter(([key]) =>
              ["6AM", "7AM", "8AM", "9AM", "10AM", "11AM", "12PM", "1PM", "2PM", "3PM", "4PM", "5PM", "6PM", "7PM", "8PM", "9PM", "10PM", "11PM", "12AM"].includes(key)
            )
          ),
        }));
        console.log("initialInputsWeekendVisitor::",initialInputsWeekendVisitor);
        
        setVisitorInputsWeekend(initialInputsWeekendVisitor);
      }

      if (employeeDataWeekend.length > 0) {
        const intialInputesEmployeeWeekend = employeeDataWeekend.map((employeeWeekend,index)=>({
          id: index + 1,
          time: employeeWeekend.day_of_week,
          category:employeeWeekend.time_of_day,
          parker: employeeWeekend.parker || 0, 
          data: Object.fromEntries(
            Object.entries(employeeWeekend).filter(([key]) =>
              ["6AM", "7AM", "8AM", "9AM", "10AM", "11AM", "12PM", "1PM", "2PM", "3PM", "4PM", "5PM", "6PM", "7PM", "8PM", "9PM", "10PM", "11PM", "12AM"].includes(key)
            )
          ),
        }))
        console.log("intialInputesEmployeeWeekend::",intialInputesEmployeeWeekend);
        setEmployeeInputsWeekend(intialInputesEmployeeWeekend)
      }
    
  }, [visitorData,employeeData,visitorDataWeekend,employeeDataWeekend]);

  console.log("visitorInputs::",visitorInputs);
  console.log("visitorInputs Weekend::",visitorInputsWeekend);
  console.log("employeeInputs::",employeeInputs);
  console.log("employeeInputs Weekend::",employeeInputsWeekend);

  // console.log("visitorInputsWeekend::",visitorInputsWeekend);

  const handleSaveCustomModal= ()=>{
    setcustomName("");
    setisModalVisible(true)
  }
  const handleCancelModal = ()=>{
    setisModalVisible(false)
  }
  const handleSaveCustom = async ()=>{
    setisModalVisible(true)
    if(customName === ""){
      return;
    }
    const combinedInputs = [
      ...[visitorInputs, visitorInputsWeekend, employeeInputs, employeeInputsWeekend].flat().map((input) => ({
        ...input.data,
        time: input.time,
        parker: input.parker,
        category: input.category,
      })),
    ];
    console.log("combinedInputs::",combinedInputs);
    
    const payload = {
      // land_use_name: customCategory?.data[0]?.land_use + '_Copy',
      copied_land_use:customCategory?.data[0]?.land_use,
      land_use_name: customName, 
      land_use_category: selectedCategoryName,   
      status: "custom",              
      // unit: "sf GLA",
      unit: selectedUnitValue,               
      season: ["Weekday", "Weekend"], 
      // parker: ["Visitor/Customer", "Employee"], 
      parker:Object.values(customCategoryCopyWeekday.parkers),
      base_ratio: [
        {
          time: "Weekday",
          parker: customCategory?.parkers.weekday_visitor,
          unit: selectedUnitValue,
          value: parseFloat(customVistorBaseRatio) || 0, 
        },
        {
          time: "Weekend",
          parker: customCategory?.parkers.weekday_visitor,
          unit: selectedUnitValue,
          value: parseFloat(customVistorBaseRatioWeekend) || 0, 
        },
        {
          time: "Weekday",
          parker: customCategory?.parkers.weekday_employee,
          unit: selectedUnitValue,
          value: parseFloat(customEmployeeBaseRatio) || 0, 
        },
        {
          time: "Weekend",
          parker: customCategory?.parkers.weekday_employee,
          unit: selectedUnitValue,
          value: parseFloat(customEmployeeBaseRatioWeekend) || 0, 
        },
      ],
      monthly_ratio: [
        {
          time: "Weekday",
          parker: "Visitor/Customer",
          jan: customVisitorJan,
          feb: customVisitorFeb,
          mar: customVisitorMar,
          apr: customVisitorApr,
          may: customVisitorMay,
          jun: customVisitorJun,
          jul: customVisitorJul,
          aug: customVisitorAug,
          sep: customVisitorSep,
          oct: customVisitorOct,
          nov: customVisitorNov,
          dec: customVisitorDec,
          late_dec: customVisitorLateDec
        },
        {
          time: "Weekend",
          parker: "Visitor/Customer",
          jan: customVisitorJanWeekend,
          feb: customVisitorFebWeekend,
          mar: customVisitorMarWeekend,
          apr: customVisitorAprWeekend,
          may: customVisitorMayWeekend,
          jun: customVisitorJunWeekend,
          jul: customVisitorJulWeekend,
          aug: customVisitorAugWeekend,
          sep: customVisitorSepWeekend,
          oct: customVisitorOctWeekend,
          nov: customVisitorNovWeekend,
          dec: customVisitorDecWeekend,
          late_dec: customVisitorLateDecWeekend
        },
        {
          time: "Weekday",
          parker: "Employee",
          jan: customEmployeeJan,
          feb: customEmployeeFeb,
          mar: customEmployeeMar,
          apr: customEmployeeApr,
          may: customEmployeeMay,
          jun: customEmployeeJun,
          jul: customEmployeeJul,
          aug: customEmployeeAug,
          sep: customEmployeeSep,
          oct: customEmployeeOct,
          nov: customEmployeeNov,
          dec: customEmployeeDec,
          late_dec: customEmployeeLateDec
        },
        {
          time: "Weekend",
          parker: "Employee",
          jan: customEmployeeJanWeekend,
          feb: customEmployeeFebWeekend,
          mar: customEmployeeMarWeekend,
          apr: customEmployeeAprWeekend,
          may: customEmployeeMayWeekend,
          jun: customEmployeeJunWeekend,
          jul: customEmployeeJulWeekend,
          aug: customEmployeeAugWeekend,
          sep: customEmployeeSepWeekend,
          oct: customEmployeeOctWeekend,
          nov: customEmployeeNovWeekend,
          dec: customEmployeeDecWeekend,
          late_dec: customEmployeeLateDecWeekend
        }
      ],
      time_ratio: combinedInputs,
      driving_adj:[
                    {
                        time:"Weekday",
                        category:"Daytime",
                        parker:customCategory?.parkers.weekday_visitor,
                        value: parseFloat(customVisitorDaytimeDrivingRatio) || 0,
                    },
                    {
                        time:"Weekday",
                        category:"Evening",
                        parker:customCategory?.parkers.weekday_visitor,
                        value: parseFloat(customVisitorEveningDrivingRatio) || 0,
                    },
                    {
                        time:"Weekend",
                        category:"Daytime",
                        parker:customCategory?.parkers.weekday_visitor,
                        value: parseFloat(customVisitorDaytimeDrivingRatioWeekend) || 0,
                    },
                    {
                        time:"Weekend",
                        category:"Evening",
                        parker:customCategory?.parkers.weekday_visitor,
                        value: parseFloat(customVisitorEveningDrivingRatioWeekend) || 0,
                    },
                    {
                        time:"Weekday",
                        category:"Daytime",
                        parker:customCategory?.parkers.weekday_employee,
                        value: parseFloat(customEmployeeDaytimeDrivingRatio) || 0,
                    },
                    {
                        time:"Weekday",
                        category:"Evening",
                        parker:customCategory?.parkers.weekday_employee,
                        "value": parseFloat(customEmployeeEveningDrivingRatio) || 0,
                    },
                    {
                        time:"Weekend",
                        category:"Daytime",
                        parker:customCategory?.parkers.weekday_employee,
                        value: parseFloat(customEmployeeDaytimeDrivingRatioWeekend) || 0,
                    },
                    {
                        time:"Weekend",
                        category:"Evening",
                        parker:customCategory?.parkers.weekday_employee,
                        value: parseFloat(customEmployeeEveningDrivingRatioWeekend) || 0,
                    }
                ],
              captive_ratio:[
                  {
                      time:"Weekday",
                      category:"Daytime",
                      parker:"Visitor/Customer",
                      value: parseFloat(customVisitorDaytimeCaptiveRatio) || 0,
                  },
                  {
                      time:"Weekday",
                      category:"Evening",
                      parker:"Visitor/Customer",
                      value: parseFloat(customVisitorEveningCaptiveRatio) || 0,
                  },
                  {
                      time:"Weekend",
                      category:"Daytime",
                      parker:"Visitor/Customer",
                      value: parseFloat(customVisitorDaytimeCaptiveRatioWeekend) || 0,
                  },
                  {
                      time:"Weekend",
                      category:"Evening",
                      parker:"Visitor/Customer",
                      value: parseFloat(customVisitorEveningCaptiveRatioWeekend) || 0,
                  },
                  {
                      time:"Weekday",
                      category:"Daytime",
                      parker:"Employee",
                      value: parseFloat(customEmployeeDaytimeCaptiveRatio) || 0,
                  },
                  {
                      time:"Weekday",
                      category:"Evening",
                      parker:"Employee",
                      value: parseFloat(customEmployeeEveningCaptiveRatio) || 0,
                  },
                  {
                      time:"Weekend",
                      category:"Daytime",
                      parker:"Employee",
                      value: parseFloat(customEmployeeDaytimeCaptiveRatioWeekend) || 0,
                  },
                  {
                      time:"Weekend",
                      category:"Evening",
                      parker:"Employee",
                      value: parseFloat(customEmployeeEveningCaptiveRatioWeekend) || 0,
                  }
              ],     
              
    };
  
    // console.log("Payload:", payload);
    try {
      console.log("Payload of Save Custom:", payload);
      // const response = await post('http://192.168.96.120:5000/apis/addcustomlanduse', payload);
      const response = await post('addcustomlanduse', payload);
    
      if (response.status === 200) {
        setisModalVisible(false)
        fetchCategory()
        setOpen(false);
        notification.success({
          message: 'Land Use Added Successfully',
        });
  
      }
    } catch (error) {
      notification.error({
        message: 'Error Adding Land Use',
        description: error.message || 'An error occurred while adding land use data.',
      });
    }
  }
  

  // Tab items configuration
  const itemsWeekendModal = [
    {
      key: "1",
      label: "Base Ratio",
      children: (
        <div className="table-responsive">
          <table className="table table-dark base-ratio-table pb-0 mb-0">
            <tbody>
              <tr>
                <td style={{ width: "30%" }}>
                  {/* Visitor */}
                  {customCategoryCopyWeekend?.data?.length > 0
                  ? activeTableModal === "weekday"
                    ? customCategoryCopyWeekday.parkers?.weekday_visitor
                    : customCategoryCopyWeekend.parkers?.weekend_visitor
                  : 0}
                  
                  </td>
                <td>
                  <input type="text" className="modal-input" 
                  value={customVistorBaseRatioWeekend} 
                  onChange={(e)=>{
                    const inputValue = e.target.value;
                    if (/^\d*\.?\d*$/.test(inputValue)) {
                    setCustomVistorBaseRatioWeekend(inputValue)
                    }}
                  }
                   />
                </td>
              </tr>
              <tr>
                <td style={{ width: "30%" }}>
                  {/* Employee */}
                  {customCategoryCopyWeekend?.data?.length > 0
                  ? activeTableModal === "weekday"
                    ? customCategoryCopyWeekday.parkers?.weekday_employee
                    : customCategoryCopyWeekend.parkers?.weekend_employee
                  : 0}
                  
                  </td>
                <td>
                  <input type="text" className="modal-input" 
                  value={customEmployeeBaseRatioWeekend} 
                  onChange={(e)=>{
                    const inputValue = e.target.value;
                    if (/^\d*\.?\d*$/.test(inputValue)) {
                    setCustomEmployeeBaseRatioWeekend(inputValue)
                    }}
                }/>
                </td>
              </tr>
              {/* <tr>
                <td style={{ width: "30%" }}>Total</td>
                <td>
                  <input type="text" className="modal-input" value="15.25" />
                </td>
              </tr> */}
            </tbody>
          </table>
        </div>
      ),
    },
    {
      key: "2",
      label: "Monthly Ratio",
      children: (
        <div className="table-responsive">
          <table className="table table-dark base-ratio-table pb-0 mb-0">
            <tbody>
              <tr className="text-center">
                <td></td>
                <td>Jan</td>
                <td>Feb</td>
                <td>Mar</td>
                <td>Apr</td>
                <td>May</td>
                <td>Jun</td>
                <td>Jul</td>
                <td>Aug</td>
                <td>Sep</td>
                <td>Oct</td>
                <td>Nov</td>
                <td>Dec</td>
                <td>Last Dec</td>
              </tr>
              <tr>
                <td>
                  {/* Visitor */}
                  {customCategoryCopyWeekend?.data?.length > 0
                  ? activeTableModal === "weekday"
                    ? customCategoryCopyWeekday.parkers?.weekday_visitor
                    : customCategoryCopyWeekend.parkers?.weekend_visitor
                  : 0}
                  
                  </td>
                <td>
                  <input type="text" className="modal-input" 
                  value={customVisitorJanWeekend} 
                  onChange={(e)=>{
                    const inputValue = e.target.value;
                if (/^\d*\.?\d*$/.test(inputValue)) {
                  setCustomVisitorJanWeekend(inputValue)
                }}
                  } />
                </td>
                <td>
                  <input type="text" className="modal-input" 
                  value={customVisitorFebWeekend} 
                  onChange={(e)=>{
                    const inputValue = e.target.value;
                if (/^\d*\.?\d*$/.test(inputValue)) {
                  setCustomVisitorFebWeekend(inputValue)
                }}
                  } />
                </td>
                <td>
                  <input type="text" className="modal-input" 
                  value={customVisitorMarWeekend} 
                  onChange={(e)=>{
                    const inputValue = e.target.value;
                if (/^\d*\.?\d*$/.test(inputValue)) {
                    setCustomVisitorMarWeekend(inputValue)
                }}

                  } 
                  />
                </td>
                <td>
                  <input type="text" className="modal-input" 
                  value={customVisitorAprWeekend} 
                  onChange={(e)=>{
                    const inputValue = e.target.value;
                if (/^\d*\.?\d*$/.test(inputValue)) {
                  setCustomVisitorAprWeekend(inputValue)
                }}
                } />
                </td>
                <td>
                  <input type="text" className="modal-input" 
                  value={customVisitorMayWeekend} 
                  onChange={(e)=>{
                    const inputValue = e.target.value;
                if (/^\d*\.?\d*$/.test(inputValue)) {
                  setCustomVisitorMayWeekend(inputValue)
                }}
                  } />
                </td>
                <td>
                  <input type="text" className="modal-input" 
                  value={customVisitorJunWeekend} 
                  onChange={(e)=>{
                    const inputValue = e.target.value;
                if (/^\d*\.?\d*$/.test(inputValue)) {
                  setCustomVisitorJunWeekend(inputValue)
                }}
                  } />
                </td>
                <td>
                  <input type="text" className="modal-input" 
                  value={customVisitorJulWeekend} 
                  onChange={(e)=>{
                    const inputValue = e.target.value;
                if (/^\d*\.?\d*$/.test(inputValue)) {
                  setCustomVisitorJulWeekend(inputValue)
                }}
                  } />
                </td>
                <td>
                  <input type="text" className="modal-input" 
                  value={customVisitorAugWeekend} 
                  onChange={(e)=>{
                    const inputValue = e.target.value;
                if (/^\d*\.?\d*$/.test(inputValue)) {
                    setCustomVisitorAugWeekend(inputValue)
                
                  }}

                  } />
                </td>
                <td>
                  <input type="text" className="modal-input" 
                  value={customVisitorSepWeekend} 
                  onChange={(e)=>{
                    const inputValue = e.target.value;
                if (/^\d*\.?\d*$/.test(inputValue)) {
                  setCustomVisitorSepWeekend(inputValue)
                }}
                  } />
                </td>
                <td>
                  <input type="text" className="modal-input" 
                  value={customVisitorOctWeekend} 
                  onChange={(e)=>{
                    const inputValue = e.target.value;
                if (/^\d*\.?\d*$/.test(inputValue)) {
                  setCustomVisitorOctWeekend(inputValue)
                }}
                  } />
                </td>
                <td>
                  <input type="text" className="modal-input" 
                  value={customVisitorNovWeekend} 
                  onChange={(e)=>{
                    const inputValue = e.target.value;
                if (/^\d*\.?\d*$/.test(inputValue)) {
                    setCustomVisitorNovWeekend(inputValue)
                }}

                  } />
                </td>
                <td>
                  <input type="text" className="modal-input" 
                  value={customVisitorDecWeekend} 
                  onChange={(e)=>{
                    const inputValue = e.target.value;
                if (/^\d*\.?\d*$/.test(inputValue)) {
                  setCustomVisitorDecWeekend(inputValue)
                }}
                  } />
                </td>
                <td>
                  <input type="text" className="modal-input" 
                  value={customVisitorLateDecWeekend} 
                  onChange={(e)=>{
                    const inputValue = e.target.value;
                if (/^\d*\.?\d*$/.test(inputValue)) {
                  setCustomVisitorLateDecWeekend(inputValue)
                }}
                } />
                </td>
              </tr>
              <tr>
                <td>
                  {/* Employee */}
                  {customCategoryCopyWeekend?.data?.length > 0
                  ? activeTableModal === "weekday"
                    ? customCategoryCopyWeekday.parkers?.weekday_employee
                    : customCategoryCopyWeekend.parkers?.weekend_employee
                  : 0}
                  
                  </td>
                <td>
                  <input type="text" className="modal-input" 
                  value={customEmployeeJanWeekend} 
                  onChange={(e)=>{
                    const inputValue = e.target.value;
                if (/^\d*\.?\d*$/.test(inputValue)) {
                    setCustomEmployeeJanWeekend(e.target.value)
                  }}

                  } />
                </td>
                <td>
                  <input type="text" className="modal-input" 
                  value={customEmployeeFebWeekend} 
                  onChange={(e)=>{
                    const inputValue = e.target.value;
                if (/^\d*\.?\d*$/.test(inputValue)) {
                  setCustomEmployeeFebWeekend(inputValue)
                }}
                } />
                </td>
                <td>
                  <input type="text" className="modal-input" 
                  value={customEmployeeMarWeekend} 
                  onChange={(e)=>{
                    const inputValue = e.target.value;
                if (/^\d*\.?\d*$/.test(inputValue)) {
                  setCustomEmployeeMarWeekend(inputValue)
                }}
                } />
                </td>
                <td>
                  <input type="text" className="modal-input" 
                  value={customEmployeeAprWeekend} 
                  onChange={(e)=>{
                    const inputValue = e.target.value;
                if (/^\d*\.?\d*$/.test(inputValue)) {
                  setCustomEmployeeAprWeekend(inputValue)
                }}
                  } />
                </td>
                <td>
                  <input type="text" className="modal-input" 
                  value={customEmployeeMayWeekend} 
                  onChange={(e)=>{
                    const inputValue = e.target.value;
                if (/^\d*\.?\d*$/.test(inputValue)) {
                    setCustomEmployeeMayWeekend(inputValue)
                  }}

                  } />
                </td>
                <td>
                  <input type="text" className="modal-input" 
                  value={customEmployeeJunWeekend} 
                  onChange={(e)=>{
                    const inputValue = e.target.value;
                if (/^\d*\.?\d*$/.test(inputValue)) {
                    setCustomEmployeeJunWeekend(inputValue)
                }}

                  } />
                </td>
                <td>
                  <input type="text" className="modal-input" 
                  value={customEmployeeJulWeekend} 
                  onChange={(e)=>{
                    const inputValue = e.target.value;
                if (/^\d*\.?\d*$/.test(inputValue)) {
                  setCustomEmployeeJulWeekend(inputValue)
                }}
                } />
                </td>
                <td>
                  <input type="text" className="modal-input" 
                  value={customEmployeeAugWeekend} 
                  onChange={(e)=>{
                    const inputValue = e.target.value;
                if (/^\d*\.?\d*$/.test(inputValue)) {
                    setCustomEmployeeAugWeekend(inputValue)
                }}

                  } />
                </td>
                <td>
                  <input type="text" className="modal-input" 
                  value={customEmployeeSepWeekend} 
                  onChange={(e)=>{
                    const inputValue = e.target.value;
                if (/^\d*\.?\d*$/.test(inputValue)) {
                  setCustomEmployeeSepWeekend(inputValue)
                  }}
                  } />
                </td>
                <td>
                  <input type="text" className="modal-input" 
                  value={customEmployeeOctWeekend} 
                  onChange={(e)=>{
                    const inputValue = e.target.value;
                if (/^\d*\.?\d*$/.test(inputValue)) {
                  setCustomEmployeeOctWeekend(inputValue)
                }}
                  } 
                  />
                </td>
                <td>
                  <input type="text" className="modal-input" 
                  value={customEmployeeNovWeekend} 
                  onChange={(e)=>{
                    const inputValue = e.target.value;
                if (/^\d*\.?\d*$/.test(inputValue)) {
                  setCustomEmployeeNovWeekend(inputValue)
                }}
                  } />
                </td>
                <td>
                  <input type="text" className="modal-input" 
                  value={customEmployeeDecWeekend} 
                  onChange={(e)=>{
                    const inputValue = e.target.value;
                if (/^\d*\.?\d*$/.test(inputValue)) {
                  setCustomEmployeeDecWeekend(inputValue)
                }}
                  } />
                </td>
                <td>
                  <input type="text" className="modal-input" 
                  value={customEmployeeLateDecWeekend} 
                  onChange={(e)=>{
                    const inputValue = e.target.value;
                if (/^\d*\.?\d*$/.test(inputValue)) {
                  setCustomEmployeeLateDecWeekend(inputValue)
                }}
                } />
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      ),
    },
    {
      key: "3",
      label: "Hourly Ratio",
      children: (
        <div className="table-responsive">
          <table className="table table-dark base-ratio-table pb-0 mb-0">
            <tbody>
              <tr className="text-center">
                <td></td>
                <td>6AM</td>
                <td>7AM</td>
                <td>8AM</td>
                <td>9AM</td>
                <td>10AM</td>
                <td>11AM</td>
                <td>12PM</td>
                <td>1PM</td>
                <td>2PM</td>
                <td>3PM</td>
                <td>4PM</td>
                <td>5PM</td>
                <td>6PM</td>
                <td>7PM</td>
                <td>8PM</td>
                <td>9PM</td>
                <td>10PM</td>
                <td>11PM</td>
                <td>12AM</td>
              </tr>

              {
                visitorInputsWeekend.map((visitor, rowIndex) => (
                  <tr key={visitor.id}>
                    {/* Parker column */}
                    <td>{visitor.parker}</td>

                    {/* Render columns in fixed order */}
                    {columnKeys.map((key, colIndex) => (
                      <td key={colIndex}>
                        <input
                          type="text"
                          className="modal-input"
                          value={visitor.data[key] || 0} // Default value if key is missing
                          onChange={(e) =>{
                            const inputValue = e.target.value;
                            if (/^\d*\.?\d*$/.test(inputValue)) {
                            handleInputChangeWeekend(visitor.id, key, inputValue)
                            }}
                          }
                        />
                      </td>
                    ))}
                  </tr>
                ))}

              {
                employeeInputsWeekend.map((employee, rowIndex) => (
                  <tr key={employee.id}>
                    {/* Parker column */}
                    <td>{employee.parker}</td>

                    {/* Render columns in fixed order */}
                    {columnKeys.map((key, colIndex) => (
                      <td key={colIndex}>
                        <input
                          type="text"
                          className="modal-input"
                          value={employee.data[key] || 0} // Default value if key is missing
                          onChange={(e) =>{
                            const inputValue = e.target.value;
                            if (/^\d*\.?\d*$/.test(inputValue)) {
                            handleEmployeeInputChangeWeekend(employee.id, key, inputValue)
                            }}
                          }
                        />
                      </td>
                    ))}
                  </tr>
              ))}


              {/* // */}
              {/* <tr>
                <td>
                  {customCategory?.data?.length > 0
                  ? activeTableModal === "weekday"
                    ? customCategory.parkers?.weekday_visitor
                    : customCategory.parkers?.weekday_visitor
                  : 0}
                  </td>
                <td>
                  <input type="text" className="modal-input" value="88%" />
                </td>
                <td>
                  <input type="text" className="modal-input" value="88%" />
                </td>
                <td>
                  <input type="text" className="modal-input" value="88%" />
                </td>
                <td>
                  <input type="text" className="modal-input" value="88%" />
                </td>
                <td>
                  <input type="text" className="modal-input" value="88%" />
                </td>
                <td>
                  <input type="text" className="modal-input" value="88%" />
                </td>
                <td>
                  <input type="text" className="modal-input" value="88%" />
                </td>
                <td>
                  <input type="text" className="modal-input" value="88%" />
                </td>
                <td>
                  <input type="text" className="modal-input" value="88%" />
                </td>
                <td>
                  <input type="text" className="modal-input" value="88%" />
                </td>
                <td>
                  <input type="text" className="modal-input" value="88%" />
                </td>
                <td>
                  <input type="text" className="modal-input" value="88%" />
                </td>
                <td>
                  <input type="text" className="modal-input" value="88%" />
                </td>
              </tr> */}
              {/* <tr>
                <td>
                  
                  {customCategory?.data?.length > 0
                  ? activeTableModal === "weekday"
                    ? customCategory.parkers?.weekday_employee
                    : customCategory.parkers?.weekday_employee
                  : 0}
                  
                  </td>
                <td>
                  <input type="text" className="modal-input" value="88%" />
                </td>
                <td>
                  <input type="text" className="modal-input" value="88%" />
                </td>
                <td>
                  <input type="text" className="modal-input" value="88%" />
                </td>
                <td>
                  <input type="text" className="modal-input" value="88%" />
                </td>
                <td>
                  <input type="text" className="modal-input" value="88%" />
                </td>
                <td>
                  <input type="text" className="modal-input" value="88%" />
                </td>
                <td>
                  <input type="text" className="modal-input" value="88%" />
                </td>
                <td>
                  <input type="text" className="modal-input" value="88%" />
                </td>
                <td>
                  <input type="text" className="modal-input" value="88%" />
                </td>
                <td>
                  <input type="text" className="modal-input" value="88%" />
                </td>
                <td>
                  <input type="text" className="modal-input" value="88%" />
                </td>
                <td>
                  <input type="text" className="modal-input" value="88%" />
                </td>
                <td>
                  <input type="text" className="modal-input" value="88%" />
                </td>
              </tr> */}
            </tbody>
          </table>
        </div>
      ),
    },
    {
      key: "4",
      label: "Captive Ratio",
      children: (
        <div className="table-responsive">
          <table className="table table-dark base-ratio-table pb-0 mb-0">
            <tbody>
              <tr>
                <td></td>
                
                <td>Daytime</td>
                <td>Evening</td>
              </tr>
              <tr>
                <td>
                  {/* Visitor */}
                  {customCategoryCopyWeekend?.data?.length > 0
                  ? activeTableModal === "weekday"
                    ? customCategoryCopyWeekday.parkers?.weekday_visitor
                    : customCategoryCopyWeekend.parkers?.weekend_visitor
                  : 0}
                  
                  </td>
               
                <td>
                  <input type="text" className="modal-input" 
                  value={customVisitorDaytimeCaptiveRatioWeekend} 
                  onChange={(e)=>{
                    const inputValue = e.target.value;
                    if (/^\d*\.?\d*$/.test(inputValue)) {
                    setCustomVisitorDaytimeCaptiveRatioWeekend(inputValue)
                    }}
                  } 
                  />
                </td>
                <td>
                  <input type="text" className="modal-input" 
                  value={customVisitorEveningCaptiveRatioWeekend} 
                  onChange={(e)=>{
                    const inputValue = e.target.value;
                    if (/^\d*\.?\d*$/.test(inputValue)) {
                    setCustomVisitorEveningCaptiveRatioWeekend(inputValue)
                    }}

                  } 
                  />
                </td>
              </tr>
              <tr>
                <td>
                  {/* Employee */}
                  {customCategoryCopyWeekend?.data?.length > 0
                  ? activeTableModal === "weekday"
                    ? customCategoryCopyWeekday?.weekday_employee
                    : customCategoryCopyWeekend.parkers?.weekend_employee
                  : 0}
                  </td>
               
                <td>
                  <input type="text" className="modal-input" 
                  value={customEmployeeDaytimeCaptiveRatioWeekend} 
                  onChange={(e)=>{
                    const inputValue = e.target.value;
                    if (/^\d*\.?\d*$/.test(inputValue)) {
                  setCustomEmployeeDaytimeCaptiveRatioWeekend(inputValue)
                    }}
                }
                />
                </td>
                <td>
                  <input type="text" className="modal-input"  
                  value={customEmployeeEveningCaptiveRatioWeekend} 
                  onChange={(e)=>{
                    const inputValue = e.target.value;
                    if (/^\d*\.?\d*$/.test(inputValue)) {
                    setCustomEmployeeEveningCaptiveRatioWeekend(inputValue)
                    }}

                  } 
                  />
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      ),
    },
    {
      key: "5",
      label: "Driving Adjustment",
      children: (
        <div className="table-responsive">
          <table className="table table-dark base-ratio-table pb-0 mb-0">
            <tbody>
            <tr>
                <td></td>
                <td>Daytime</td>
                <td>Evening</td>
              </tr>
              <tr>
                <td>
                  {/* Visitor */}
                  {customCategoryCopyWeekend?.data?.length > 0
                  ? activeTableModal === "weekday"
                    ? customCategoryCopyWeekday.parkers?.weekday_visitor
                    : customCategoryCopyWeekend.parkers?.weekend_visitor
                  : 0}
                  </td>
                <td>
                  <input type="text" className="modal-input" 
                  value={customVisitorDaytimeDrivingRatioWeekend} 
                  onChange={(e)=>{
                    const inputValue = e.target.value;
                    if (/^\d*\.?\d*$/.test(inputValue)) {
                  setCustomVisitorDaytimeDrivingRatioWeekend(inputValue)
                    }}
                  } 
                  />
                </td>
                <td>
                  <input type="text" className="modal-input" 
                  value={customVisitorEveningDrivingRatioWeekend} 
                  onChange={(e)=>{
                    const inputValue = e.target.value;
                    if (/^\d*\.?\d*$/.test(inputValue)) {
                    setCustomVisitorEveningDrivingRatioWeekend(inputValue)
                  }}

                  } />
                </td>
              </tr>
              <tr>
                <td>
                  {/* Employee */}
                  {customCategoryCopyWeekend?.data?.length > 0
                  ? activeTableModal === "weekday"
                    ? customCategoryCopyWeekday.parkers?.weekday_employee
                    : customCategoryCopyWeekend.parkers?.weekend_employee
                  : 0}
                  </td>
               
                <td>
                  <input type="text" className="modal-input" 
                  value={customEmployeeDaytimeDrivingRatioWeekend} 
                  onChange={(e)=>{
                    const inputValue = e.target.value;
                    if (/^\d*\.?\d*$/.test(inputValue)) {
                    setCustomEmployeeDaytimeDrivingRatioWeekend(inputValue)
                    }}
                  } 
                  />
                </td>
                <td>
                  <input type="text" className="modal-input" 
                  value={customEmployeeEveningDrivingRatioWeekend} 
                  onChange={(e)=>{
                    const inputValue = e.target.value;
                    if (/^\d*\.?\d*$/.test(inputValue)) {
                  setCustomEmployeeEveningDrivingRatioWeekend(inputValue)
                    }}
                  } 
                  />
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      ),
    },
  ];
  return (
    <>
      {/* <div className="d-flex align-items-center justify-content-center mb-5">
                <div>
                    <a href="" className="number-active action-completed" >
                    <img src={TickImg} alt="" className="" />
                     </a>
                </div>
                <div className="line"></div>
                <div>
                    <a href="" className="number-active" >2 </a>
                </div>
            </div> */}
      {/* {loading ? (
        <div>
          <Loading />
        </div>
      ) : ( */}
        <>
          <div className="row">
            <div className="d-flex align-items-center">
              <AdminSidebar />
              <div className="col-size-3">
                <div className="inside-filter p-0">
                  <h5 className="mb-2" style={{padding: '20px 20px 0 20px'}}>Configuration</h5>
                  <div className="mb-3 px-3">
                    <input type="text" className="form-control" placeholder="Search" onChange={(e) => setSearchTerm(e.target.value)} />
                  </div>
                  <p style={{ fontSize: "16px", marginBottom: "5px", padding: '0 20px' }} className="">
                    Category
                  </p>
                  <Collapse
                    // defaultActiveKey={["1"]}
                    ghost
                    className="configuration-sidebar"
                    expandIcon={({ isActive }) =>
                      isActive ? <MinusOutlined /> : <PlusOutlined />
                    }
                  >
                    {/* {itemsSidebar.map((item) => (
                      <Panel header={item.label} key={item.key}>
                        {item.children}
                      </Panel>
                    ))} */}
                    {/* {categoryList.map((category,index)=>( */}
                    {filteredCategories.map((category, index) => (
                      <Panel header={category.category_name} key={index}>
                        <ul className="category-style">
                        {category.land_uses.map((land,land_index)=>(
                          <li 
                          key={land.land_use_id}
                          className={landuseID === land.land_use_id ? "active":""}
                          >
                            <span 
                            className="category-list"
                            title={land.land_use_name}
                            onClick={()=>handleCategorylist(land.land_use_id,category.category_name)}
                            >
                              {land.land_use_name}
                            </span>
                            <span
                        className={
                          land.default === "default"
                            ? "default-style"
                            : "custom-style"
                        }
                      >
                        {land.default.toUpperCase()}
                      </span>

                          </li>

                        ))}
                        </ul>
                      </Panel>
                    ))}
                  </Collapse>
                </div>
              </div>
              <div className="col-size-5 tabs-filters base-ratio">
                <div
                  className="inside-filter"
                  style={{ background: "transparent" }}
                >
                  <div className="d-flex align-items-center justify-content-end mb-4">
                    {/* <div className="my-2 d-flex align-items-center position-relative">
                      <span
                        className="position-absolute top-4"
                        style={{ left: "10px" }}
                      >
                        <img
                          src={SearchIconImg}
                          alt=""
                          style={{ width: "18px" }}
                        />
                      </span>
                      <input
                        type="search"
                        className="form-control ps-5"
                        placeholder="search"
                      />
                    </div> */}

                 
                    
                    {Array.isArray(customCategory?.data) && customCategory.data[0]?.admin === adminId && (
                      <>
                    <div className="action-style" style={{marginRight: '10px'}}>
                      <img src={DeleteRatioImg} alt="delete icon" onClick={customDeleteModal}/>
                    </div>
                    <div className={`action-style ${isEditMode && customCategory.data[0]?.admin === adminId ? 'active-edit' : ''}`} onClick={handleEditMode}>
                    {isEditMode && customCategory.data[0]?.admin === adminId ? (
                        <img src={CloseImg} alt="Close" />
                      ) : (
                        <img src={EditRatioImg} alt="Edit" />
                      )}
                    </div>
                    </>
                   )}  
                      {isEditMode && customCategory.data[0]?.admin === adminId &&(
                    <div>
                      <a
                        onClick={handleEditRatios}
                        style={{
                          display: "flex",
                          alignItems: "baseline",
                          padding: "8px 23px",
                          borderRadius: "20px",
                          background: "#000",
                          border: "1px solid #DDDEDF",
                          marginLeft: "15px",
                          color: "#fff",
                          fontSize: "16px",
                          cursor: "pointer",
                        }}
                      >
                        <span>Update </span>
                      </a>
                    </div>
                    )}
                    {(customCategory?.data?.length > 0 || 
                        customCategoryCopyWeekday?.data?.length > 0 || 
                        customCategoryCopyWeekend?.data?.length > 0) && (
                    <div>
                    {/* {customCategory.length > 0 &&( */}
                      <a
                        onClick={showDrawer}
                        style={{
                          display: "flex",
                          alignItems: "baseline",
                          padding: "8px 23px",
                          borderRadius: "20px",
                          background: "#000",
                          border: "1px solid #DDDEDF",
                          marginLeft: "15px",
                          color: "#fff",
                          fontSize: "16px",
                          cursor: "pointer",
                        }}
                      >
                        <img src={AddImg} alt="" className="me-2" />{" "}
                        <span>Custom </span>
                      </a>
                     {/* )}  */}
                    </div>
                    )}
                   
                  </div>
                  <div
                    className="d-flex align-items-center justify-content-between mt-2 pb-3"
                    style={{ borderBottom: "1px dashed #DDDDDD" }}
                  >
                    <div>
                    {isEditMode ? (
                      <input
                        type="text"
                        value={editedLandUseName}
                        onChange={(e) => setEditedLandUseName(e.target.value)}
                        style={{
                          fontSize: "20px",
                          padding: "5px",
                          border: "1px solid #F0F0F1",
                          borderRadius: "10px",
                        }}
                      />
                    ) : (
                      <h5 className="mb-0" style={{ fontSize: "20px" }}>
                        {customCategory?.data?.length > 0 &&
                        customCategory?.data[0]?.land_use
                        }
                      </h5>
                    )}
                      <p
                        className="mb-0"
                        style={{ fontSize: "14px", color: "#00000080" }}
                      >
                        {customCategory?.data?.length > 0 &&
                        customCategory?.data[0]?.unit 
                        }
                        
                      </p>
                      
                      <p
                        className="mb-0"
                        style={{ fontSize: "11px", color: "#00000080" }}
                      > 
                        {customCategory?.data?.length > 0 && customCategory?.data[0]?.copied_landuse !== null &&
                        "copied from " +
                        customCategory?.data[0]?.copied_landuse
                        
                        }
                        
                        
                      </p>
                    </div>
                    {(customCategory?.data?.length > 0 || 
                        customCategoryCopyWeekday?.data?.length > 0 || 
                        customCategoryCopyWeekend?.data?.length > 0) && (
                    <div
                      className="d-flex align-items-center"
                      style={{ borderRadius: "5px" }}
                    >
                     
                      <div
                        onClick={() => setActiveTable("weekday")}
                        style={{
                          cursor: "pointer",
                          padding: "18px 40px",
                          fontWeight: "300",
                          background:
                            activeTable === "weekday" ? "#A4DEC8" : "#ECF4F5",
                          borderRadius: "5px 0 0 5px",
                        }}
                      >
                        <h4
                          style={{ fontSize: "15px", fontWeight: "400" }}
                          className="mb-0"
                        >
                          Weekday
                        </h4>
                      </div>
                      <div
                        onClick={() => setActiveTable("weekend")}
                        style={{
                          cursor: "pointer",
                          padding: "18px 40px",
                          fontWeight: "300",
                          background:
                            activeTable === "weekend" ? "#A4DEC8" : "#ECF4F5",
                          borderRadius: "0 5px 5px 0",
                        }}
                      >
                        <h4
                          style={{ fontSize: "15px", fontWeight: "400" }}
                          className="mb-0"
                        >
                          Weekend
                        </h4>
                      </div>
                    </div>
                        )}
                  </div>
                  {/*  */}

                  {/* {activeTable === "weekday" && (
                    <div className="mt-4">
                      <Collapse accordion items={items} />
                    </div>
                  )}

                 

                  {activeTable === "weekend" && (
                    <div className="mt-4">
                      <Collapse accordion items={itemsWeekend} />
                    </div>
                  )} */}

                    {/* <div className="mt-4">
                      <Collapse accordion items={items} />
                    </div> */}
                  {/* {loading ?(
                  <div>
                      <Loading/>
                  </div>
                    ):( <> */}

                    <div className="mt-4">
                      {customCategory?.data?.length > 0 ? (
                        <Collapse accordion  defaultActiveKey="1"  items={items} />
                      ) : (
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                            height: "200px",
                            fontSize: "16px",
                            color: "#888",
                            backgroundColor: "#f9f9f9",
                            borderRadius: "5px",
                          }}
                        >
                          Select a category to view details.
                        </div>
                      )}
                    </div>
                    {/* </>)} */}

                  {/*  */}
                </div>

                <Modal
                title=""
                visible={isModalVisible}
                onOk={handleSaveCustom}
                onCancel={handleCancelModal}
                footer={null}
            >
                {renderModalContent()}
            </Modal>

            <DeletConformation
              isVisible={isDeleteModalVisible}
              onCancel={handleDeleteModalCancel}
              onConfirm={customDelete}
              message="Are you sure you want to delete this record?" // Custom message (optional)
            />

                
              </div>
            </div>
          </div>
          {/*  */}
          <Drawer
            title=""
            onClose={onClose}
            open={open}
            width={'65%'}
            className="addbase base-ratio"
          >
            <div
              className="d-flex align-items-center justify-content-between mt-2 pb-3 flex-wrap"
              style={{ borderBottom: "1px dashed #DDDDDD" }}
            >
              <div>
                <h5 className="mb-0" style={{ fontSize: "20px",whiteSpace: 'nowrap',
                  width: '300px',
                  overflow: 'hidden',
                  textOverflow: 'ellipsis' }}
                  title= {customCategory?.data?.length > 0 &&
                    customCategory?.data[0]?.land_use
                    }
                  >
                  {/* Fine/Casual Dining_Copy */}
                  {customCategory?.data?.length > 0 &&
                        customCategory?.data[0]?.land_use
                        }
                </h5>
                <p
                  className="mb-0"
                  style={{ fontSize: "14px", color: "#00000080" }}
                >
                  {/* Food and Beverage (Weekday) */}
                </p>
              </div>
            <div className="d-flex align-items-center tab-view-style">
              <div className="me-2">
                <select
                  className="form-select"
                  style={{
                    width: "200px",
                    border: "1px solid #DDDDDD",
                    borderRadius: "5px",
                    padding: "13px 13px",
                    textTransform: 'capitalize',
                  }}
                  value={selectedUnitValue} // Bind selected value to state
                  onChange={handleUnitChange} // Attach onChange handler
                >
                  {/* Ensure "None" is the default starting option */}
                  {unitList.map((unit, index) => (
                    <option key={index} value={unit.unit_display}>
                      {unit.unit_display}
                    </option>
                  ))}
                </select>
              </div>

              <div
                className="d-flex align-items-center"
                style={{ borderRadius: "5px" }}
              >
                {/* Weekday and Weekend buttons */}
                <div
                  onClick={() => setActiveTableModal("weekday")}
                  style={{
                    cursor: "pointer",
                    padding: "18px 40px",
                    fontWeight: "300",
                    background:
                    activeTableModal === "weekday" ? "#A4DEC8" : "#ECF4F5",
                    borderRadius: "5px 0 0 5px",
                  }}
                >
                  <h4
                    style={{ fontSize: "15px", fontWeight: "400" }}
                    className="mb-0"
                  >
                    Weekday
                  </h4>
                </div>
                <div
                  onClick={() => setActiveTableModal("weekend")}
                  style={{
                    cursor: "pointer",
                    padding: "18px 40px",
                    fontWeight: "300",
                    background:
                    activeTableModal === "weekend" ? "#A4DEC8" : "#ECF4F5",
                    borderRadius: "0 5px 5px 0",
                  }}
                >
                  <h4
                    style={{ fontSize: "15px", fontWeight: "400" }}
                    className="mb-0"
                  >
                    Weekend
                  </h4>
                </div>
              </div>
              </div>
            </div>
            {/*  */}

            {activeTableModal === "weekday" && (
              <div className="mt-4">
                <Collapse accordion items={itemsModal}  activeKey={activeKeys}  onChange={handleCollapseChange}/>
              </div>
            )} 

           

            {activeTableModal === "weekend" && (
              <div className="mt-4">
                <Collapse accordion items={itemsWeekendModal} activeKey={activeKeys}  onChange={handleCollapseChange}/>
              </div>
            )}

            {/*  */}

            <div className="d-flex align-items-center w-100 justify-content-end mt-5">
              <button className="me-4 btn-outline-secondary btn" onClick={onClose}>Close</button>
              <button className="btn btn-primary" onClick={handleSaveCustomModal}>Save</button>
            </div>
          </Drawer>
          {/*  */}
        </>
      {/* )} */}
    </>
  );
};

export default RangeTable;
